export const LangFr = {
  name: 'fr',
  data: {
    sidebar: {
      dashboard: 'Accueil',
      tasks: 'Mes tâches',
      identity_validation: 'Validation d’identité',
      create: 'Créer',
      commercial: 'Commercial',
      prospection: 'Prospection',
      stats: 'Statistiques',
      companies: 'Entreprises',
      planning: 'Planning',
      recruitment: 'Recrutement',
      missions: 'Missions',
      candidates: 'Candidats',
      pools: 'Viviers',
      reviews: 'Avis',
      qualifications: 'Qualifications',
      payroll_billing: 'Paie et facturation',
      timesheets: 'Relevés d’heures',
      payroll: 'Paie',
      billing: 'Facturation',
      jobbiz_game: 'Jobbiz Game',
      intercom: 'Intercom',
      collapse: 'Réduire',
      expand: 'Agrandir',
      close_menu: 'Fermer le menu',
      open_menu: 'Ouvrir le menu',
      more: 'Plus',
      admin_members: 'Membres',
      admin_settings: 'Paramètres',
      admin_appointments: 'Rendez-vous clients',
      admin_calls: 'Appels',
      admin_goals: 'Objectifs des commerciaux',
      admin_agency_goals: 'Objectifs de l’agence',
      admin_sizes: 'Taille des clients',
      admin_etp: 'ETP',
      admin_back: 'Retour au CRM',
      soon: 'Bientôt disponible',
    },
    planning: {
      previous: 'Précédent',
      next: 'Suivant',
      today: 'Aujourd’hui',
      day: 'Jour',
      week: 'Semaine',
      add: 'Ajouter',
      loadError: 'Le planning n’a pas pu se charger.',
      retry: 'Réessayer',
      undo: 'Annuler',
      remote: 'Télétravail',
      othersOne: '+{count} autre',
      othersMany: '+{count} autres',
      untitled: '(Sans titre)',
      planningOf: 'Planning de',
      shiftStart: 'Début de service · {hour}h',
      shiftEnd: 'Fin de service · {hour}h',
      travel: '{minutes} min',
      myWeek: 'Ma semaine',
      toPlaceOne: '{count} visite à placer',
      toPlaceMany: '{count} visites à placer',
      placeVisits: 'Placer mes visites',
      progress_events: 'Rendez-vous réalisés',
      progress_tasks: 'Tâches faites',
      progress_calls: 'Appels décrochés',
      roadEstimated: 'de route estimée',
      backToWeek: 'Revenir à ma semaine',
      toPlace: 'À placer',
      toPlaceHint: 'Glissez une visite dans votre semaine, avant la date indiquée. Elles sont regroupées par secteur pour limiter la route.',
      allVisits: 'Toutes',
      noVisitTitle: 'Aucune visite à placer',
      noVisitText: 'Les visites prises en prospection s’afficheront ici, à glisser dans votre semaine.',
      visitsOne: '{count} visite',
      visitsMany: '{count} visites',
      km: '{km} km',
      alone: 'isolée',
      mostUrgentOne: 'La plus pressée, avant l’échéance',
      mostUrgentMany: 'Les {count} plus pressées, avant l’échéance',
      tourProposed: 'Tournée proposée',
      place: 'Placer',
      slot: '{day}, {from} à {to}',
      dueLate: 'en retard',
      dueTonight: 'avant ce soir',
      dueTomorrow: 'avant demain',
      dueBy: 'avant le {day}',
      morning: '{day} matin',
      afternoon: '{day} après-midi',
      placedOne: 'Visite chez {company} placée {day} à {time}',
      placedTourOne: '1 visite placée {where}',
      placedTour: '{count} visites placées {where} · {road} min de route au total',
      farTitle: 'C’est loin de votre tournée',
      farTextBefore: '{city} est à {km} km de {from}, environ {minutes} min de route avant {company} à {time}.',
      farTextAfter: '{city} est à {km} km de {from}, environ {minutes} min de route après {company} à {time}.',
      farSuggestion: '{day} à {time}',
      farOnTourMorning: 'Sur la route de votre tournée à {sector} le matin.',
      farOnTourAfternoon: 'Sur la route de votre tournée à {sector} l’après-midi.',
      placeOn: 'Placer {day}',
      keepOn: 'Garder {day}',
      cancel: 'Annuler',
      addTitle: 'Ajouter un titre',
      titleLabel: 'Titre',
      close: 'Fermer',
      type_todo: 'Tâche',
      type_meeting: 'Rendez-vous',
      noTime: 'sans heure',
      addDescription: 'Ajouter une description',
      descriptionLabel: 'Description',
      moreOptions: 'Plus d’options',
      saving: 'Un instant…',
      save: 'Enregistrer',
      meetingAdded: 'Rendez-vous ajouté',
      meetingAddedFor: 'Rendez-vous ajouté à l’agenda de {name}',
      calendarOf: 'Agenda de',
      allDayLabel: 'Toute la journée',
      startDayLabel: 'Jour de début',
      startTimeLabel: 'Heure de début',
      endDayLabel: 'Jour de fin',
      endTimeLabel: 'Heure de fin',
      taskAdded: 'Tâche ajoutée',
    },
    appointment: {
      close: 'Fermer',
      today: 'Aujourd’hui',
      tomorrow: 'Demain',
      yesterday: 'Hier',
      tabDetail: 'Détail',
      tabActivity: 'Activité',
      tabComments: 'Commentaires',
      statusDone: 'Réalisé',
      statusNoShow: 'Pas venu',
      record: 'Fiche',
      report: 'Compte rendu',
      reportPlaceholder: 'Ce qui a été dit, la prochaine étape…',
      reportSaved: 'Compte rendu enregistré',
      note: 'Note',
      history_created: 'Rendez-vous créé',
      history_done: 'Marqué comme effectué',
      history_no_show: 'Le client ne s’est pas présenté',
      history_planned: 'Rendez-vous rouvert',
      reopen: 'Rouvrir le rendez-vous',
      reopened: 'Rendez-vous rouvert',
      noShow: 'Pas venu',
      noShowDone: 'Rendez-vous non honoré',
      held: 'Réalisé',
      heldDone: 'Rendez-vous effectué',
      markDone: 'Marquer comme terminé',
      call: 'Appeler',
      seeInPlanning: 'Voir dans le planning',
      unplace: 'Retirer du planning',
      delete: 'Supprimer le rendez-vous',
      unplaced: 'Visite remise à placer',
      deleted: 'Rendez-vous supprimé',
      mode_on_site: 'Sur site',
      mode_video: 'En visio',
      mode_phone: 'Par téléphone',
      history_canceled: 'Annulé',
      history_updated: 'Rendez-vous modifié',
      edit: 'Modifier',
      cancelEdit: 'Annuler',
      saveEdit: 'Enregistrer',
      updated: 'Rendez-vous modifié',
      startLabel: 'Début',
      endLabel: 'Fin',
      dayLabel: 'Jour',
      startDayLabel: 'Jour de début',
      endDayLabel: 'Jour de fin',
      locationLabel: 'Lieu',
      allDayLabel: 'Toute la journée',
      allDay: 'Toute la journée',
      fromTo: 'Du {from} au {to}',
      calendarOf: 'Agenda de {name}',
      googleCalendar: 'Google Agenda',
    },
    clientSizes: {
      grand_compte: 'Grand compte',
      pme: 'PME',
      tpe: 'TPE',
      label: 'Taille du client',
      none: 'Non renseignée',
      saved: 'Taille du client enregistrée.',
      fromEtp:
        'Calculée d’après ses relevés d’heures : ses ETP moyens des 3 derniers mois, selon les seuils de la console d’administration.',
      required: 'Choisissez la taille du client.',
    },
    remuneration: {
      coefficientsTitle: 'Coefficients de facturation',
      editCoefficients: 'Modifier les coefficients',
      columnRate: 'Taux horaire brut',
      columnDelegation: 'Délégation',
      columnManagement: 'Gestion',
      rangeFromTo: '{from} à {to}',
      rangeOver: '> {from}',
      incomplete: 'La grille n’est pas complète.',
      attested: 'Conforme à la proposition commerciale signée · attesté le {day}',
      attestedBy: 'Conforme à la proposition commerciale signée · attesté le {day} par {name}',
      neverAttested: 'Coefficients par défaut, jamais attestés pour cette entreprise.',
      defaultData: 'Données par défaut',
      majorationsTitle: 'Majorations',
      overtime: 'Heures supplémentaires',
      overtimeText: 'au-delà de {hours} h par semaine',
      night: 'Heures de nuit',
      nightText: 'de {start} h à {end} h',
      sunday: 'Dimanche',
      holiday: 'Jours fériés',
      solidarity: 'Jour de solidarité',
      none: 'Aucun',
      advantagesTitle: 'Avantages',
      ticket: 'Ticket restaurant',
      noTicket: 'Pas de titres-restaurant',
      ticketShare: '{share} % part patronale',
      bonuses: 'Primes et indemnités',
      noBonus: 'Aucune prime ni indemnité.',
      addBonus: 'Ajouter une prime',
      removeBonus: 'Retirer {name}',
    },
    reviews: {
      tabUntreated: 'À traiter',
      tabTreated: 'Traités',
      search: 'Rechercher un intérimaire…',
      columnWorker: 'Intérimaire',
      columnMission: 'Mission',
      columnReview: 'Avis',
      missionNumber: 'n°{number}',
      openCompany: 'Voir l’entreprise',
      treat: 'Traiter l’avis',
      loading: 'Chargement des avis…',
      loadError: 'Les avis n’ont pas pu être chargés.',
      retry: 'Réessayer',
      emptyTitle_untreated: 'Aucun avis à traiter',
      emptyText_untreated: 'Les avis que les entreprises laissent à leurs intérimaires arriveront ici.',
      emptyTitle_treated: 'Aucun avis traité',
      emptyText_treated: 'Les avis traités s’afficheront ici.',
    },
    createMenu: {
      title: 'Créer',
      description: 'Que voulez-vous créer ?',
      close: 'Fermer',
      task: 'Une tâche',
      taskText: 'Une action, un appel, un e-mail ou un rendez-vous.',
      company: 'Une entreprise',
      companyText: 'Un prospect à démarcher ou une entreprise cliente.',
      mission: 'Une mission',
      missionText: 'Une mission à pourvoir pour une entreprise cliente.',
    },
    home: {
      mentions: {
        title: 'Mentions',
        inTask: 'Dans « {task} »',
        unread: 'Non lue',
        empty: 'Personne ne vous a mentionné pour l’instant.',
        loadError: 'Les mentions n’ont pas pu se charger.',
        seeAll: 'Voir tout',
        close: 'Fermer',
        retry: 'Réessayer',
        filterAll: 'Toutes',
        filterUnread: 'Non lues',
        pageRange: '{start}-{end} sur {total}',
        emptyTitle: 'Aucune mention',
        emptyText: 'Quand un collègue vous mentionne dans une tâche, son commentaire s’affiche ici.',
        emptyUnreadTitle: 'Tout est lu',
        emptyUnreadText: 'Vous avez ouvert toutes les tâches où l’on vous mentionne.',
      },
      tasks: {
        title: 'Tâches du jour',
        countOne: '{count} à faire',
        countOther: '{count} à faire',
        countLate: ', dont {count} en retard',
        add: 'Ajouter',
        addTooltip: 'Nouvelle tâche · touche N',
        addTask: 'Ajouter une tâche',
        emptyTitle: 'Aucune tâche en cours',
        emptyText: 'Vous n’avez pas de tâche prévue aujourd’hui.',
        tabAll: 'Tous',
        tabAppointments: 'Rendez-vous',
        tabCalls: 'Appels',
        tabOther: 'Tâches',
        groupLate: 'En retard',
        groupFixed: 'Planifiées',
        groupNone: 'Non planifiées',
        groupDone: 'Faites',
        moreLate: 'Voir les {count} autres tâches en retard',
        today: 'Aujourd’hui',
        yesterday: 'Hier',
        done: 'Faite',
        doneAt: 'Faite à {time}',
        markDone: 'Marquer comme faite',
        externalCheck: 'Se coche dans Google Agenda',
        markUndone: 'Marquer comme à faire',
        appointment: 'Rendez-vous',
        callList: 'Liste d’appels du jour',
        callListProgress: 'Prospection · {done} / {total} appels',
        callBack: 'Rappeler {name}',
        switchboard: 'le standard',
        doneTask: 'Tâche terminée',
        doneAppointment: 'Rendez-vous effectué',
        doneCallback: 'Rappel effectué',
        undo: 'Annuler',
      },
      order: {
        link: 'Pourquoi cet ordre ?',
        title: 'L’ordre de la liste',
        late: 'Les {count} plus récentes, les autres sont dans Mes tâches.',
        fixed: 'Celles qui ont une heure, dans l’ordre de la journée.',
        none: 'Sans heure, à faire dans la journée.',
        done: 'À la fin, repliées.',
        calls: 'Les rappels et les appels de prospection restent dans « Liste d’appels du jour ».',
      },
      calls: {
        title: 'Appels du jour',
        toQualifyOne: '{count} appel à qualifier avant de reprendre la liste.',
        toQualifyOther: '{count} appels à qualifier avant de reprendre la liste.',
        qualify: 'Qualifier l’appel',
        none: 'Aucun appel prévu aujourd’hui. Ajoutez des prospects pour lancer votre liste.',
        prospectionMode: 'Mode prospection',
        finished: 'Bravo ! {reached} contacts joints et {booked} RDV pris aujourd’hui.',
        recap: 'Voir le récap',
        leftOne: 'Encore {count} appel à passer',
        leftOther: 'Encore {count} appels à passer',
        late: ', dont {count} en retard',
        next: ' Prochain rappel à {time} : {name}.',
        someone: 'un contact',
      },
      agenda: {
        title: 'Planning',
        open: 'Ouvrir le planning',
        add: 'Ajouter un rendez-vous',
        toPlace: '{count} rendez-vous à placer',
        urgent: 'Dont {count} avant demain',
        empty: 'Aucun rendez-vous aujourd’hui.',
        emptyFree: 'Aucun rendez-vous aujourd’hui. Votre planning est libre.',
        allDay: 'Toute la journée',
        until: 'jusqu’au {day}',
      },
      loadError: 'L’accueil n’a pas pu se charger.',
      retry: 'Réessayer',
      comingSoon: 'Disponible avec le mode prospection, à venir dans app.admin.',
    },
    prospection: {
      title: 'Liste d’appels du jour',
      comingSoon: 'À venir dans app.admin.',
      commands: {
        sessions: 'Consulter mes sessions',
        edit: 'Modifier la liste',
        finishEdit: 'Terminer',
        addProspect: 'Ajouter un prospect',
      },
      banner: {
        title: 'Appels de prospection',
        discovery: 'Découvertes',
        followup: 'Relances',
        ring: '{done}/{goal}',
      },
      status: {
        editing: 'Retirez des appels, puis choisissez-en d’autres dans la liste globale.',
        finishedGoal: 'Terminée en {duration}, objectif atteint',
        finished: 'Terminée en {duration}',
        goalReached: 'Objectif du jour atteint, bravo !',
        remainingOne: 'Encore {count} appel pour l’objectif du jour.',
        remainingOther: 'Encore {count} appels pour l’objectif du jour.',
      },
      duration: {
        minutesOne: '{count} minute',
        minutesOther: '{count} minutes',
        hours: '{hours} h',
        hoursMinutes: '{hours} h {minutes}',
      },
      blocks: {
        plannedTitle: 'Planifiés',
        queueTitle: 'File d’appels',
        queueEmpty: 'La file est vide : choisissez des appels dans la liste globale.',
        done: 'Terminés',
      },
      results: {
        answered: 'Répondu',
        callback: 'À rappeler',
        no_answer: 'Sans réponse',
        not_interested: 'Pas intéressé',
      },
      sources: {
        phone: 'Téléphone',
        field: 'Terrain',
        referral: 'Recommandation',
        search: 'Recherche naturelle',
        social: 'Médias sociaux',
        inbound: 'Demande entrante',
        field_visit: 'Visite terrain',
      },
      row: {
        subline: '{source} · {city}',
        call: 'Appeler {phone}',
        remove: 'Retirer de la liste',
        removeDisabled: 'Appel en cours',
        pickGlobal: 'Choisir dans la liste globale',
      },
      tags: {
        discovery: 'Découverte',
        followup: 'Relance',
        discoveryAttempt: 'Découverte · {n}e essai',
        followupAttempt: '{n}e relance',
        atTime: '{label} · {time}',
        atDay: '{label} · {day} {time}',
      },
      toasts: {
        removed: '{company} est retiré de la liste du jour',
        postponedTomorrow: 'Rappel de {company} reporté à demain, {time}',
        postponedDay: 'Rappel de {company} reporté à {day}, {time}',
        undo: 'Annuler',
        added: '{company} ajouté à la liste',
      },
      global: {
        title: 'Liste globale',
        description: 'Vos prospects sans appel prévu : ajoutez-en à la liste du jour.',
        inDay: 'Dans la liste du jour : {discovery} découvertes sur {discoveryGoal}, {followup} relances sur {followupGoal}.',
        tabs: {
          discovery: 'Découvertes',
          followup: 'Relances',
        },
        search: 'Rechercher une entreprise, une ville, un contact',
        subline: '{contact} · {city}',
        motif: {
          inbound: 'Demande entrante du {date}',
          added: 'Ajouté le {date}',
          missedOne: '{count} appel sans réponse, le dernier le {date}',
          missedOther: '{count} appels sans réponse, le dernier le {date}',
          lastCall: 'Dernier appel le {date}',
        },
        add: 'Ajouter',
        added: 'Ajouté',
        showAll: 'Voir tous mes prospects',
        done: 'Terminer',
        emptySearchTitle: 'Aucun prospect trouvé',
        emptySearchText: 'Aucun prospect ne correspond à votre recherche.',
        emptyTab: {
          discovery: 'Aucun prospect à proposer en découverte',
          followup: 'Aucun prospect à proposer en relance',
        },
        emptyTabText: 'Ils sont tous dans une liste d’appels ou ont déjà été appelés aujourd’hui.',
      },
      idle: {
        title: 'Aucun appel en cours',
        launchOne: 'Lancez la session : les appels de la file s’enchaînent, la fiche de chaque contact s’affiche ici, puis son numéro se compose.',
        launchOther: 'Lancez la session : les {count} appels de la file s’enchaînent, la fiche de chaque contact s’affiche ici, puis son numéro se compose.',
        launch: 'Lancer la session',
        call: 'Cliquez sur « Appeler » à côté d’un prospect : sa fiche s’affiche ici pendant l’appel, pour noter ce qui s’est dit.',
        callButton: 'Appeler {name}',
      },
      empty: {
        title: 'Aucun appel prévu aujourd’hui',
        text: 'Choisissez des prospects dans la liste globale, ou ajoutez-en un nouveau.',
      },
      finished: {
        title: 'Tous les appels du jour sont passés',
        text: 'Bravo ! Vous pouvez continuer avec d’autres prospects.',
        reachedOne: '{count} contact joint',
        reachedOther: '{count} contacts joints',
        callbacksOne: '{count} rappel',
        callbacksOther: '{count} rappels',
      },
      states: {
        globalList: 'Liste globale',
        addProspect: 'Ajouter un prospect',
        loadError: 'Chargement impossible : {error}',
      },
      side: {
        finishedTitle: 'Session terminée',
        readyTitle: 'Prêt à prospecter ?',
        upcomingOne: 'Le rappel est dans vos prochaines listes d’appels.',
        upcomingOneMissed: 'Le rappel est dans vos prochaines listes d’appels, dont {count} appel sans réponse.',
        upcomingOther: 'Les {count} rappels sont dans vos prochaines listes d’appels.',
        upcomingMissedOne: 'Les {total} rappels sont dans vos prochaines listes d’appels, dont {count} appel sans réponse.',
        upcomingMissedOther: 'Les {total} rappels sont dans vos prochaines listes d’appels, dont {count} appels sans réponse.',
        upcomingNone: 'Aucun rappel prévu pour les prochains jours.',
        readyText: 'Commencez par un des prospects suggérés, ou ajoutez-en un nouveau.',
        suggested: 'Prospects suggérés',
        never: 'Jamais appelé',
        today: 'Appelé aujourd’hui',
        sinceOne: 'Aucun échange depuis {count} jour',
        sinceOther: 'Aucun échange depuis {count} jours',
        add: 'Ajouter',
        noSuggestTitle: 'Aucun prospect à suggérer',
        noSuggestText: 'Tous vos prospects sont déjà dans une liste d’appels.',
        noProspectTitle: 'Aucun prospect',
        noProspectText: 'Ajoutez vos premiers prospects.',
      },
      sheet: {
        close: 'Fermer',
      },
      qualification: {
        title: 'Résultat de l’appel',
        visit: 'Visite terrain à placer dans le planning',
        noteLabel: 'Note',
        noteRequired: 'obligatoire',
        noteOptional: 'facultative',
        notePlaceholder: 'Ce qu’il faut retenir de l’échange…',
        callbackTitle: 'Quand rappeler ?',
        callbackHint: 'Le rappel se place dans la liste d’appels, à l’heure choisie.',
        retryTitle: '{ordinal} tentative sans réponse. Quand réessayer ?',
        retryHint: 'Tentative {n} sur 3. Au 3e appel sans réponse, vous choisirez de passer en visite terrain.',
        thirdTitle: '{ordinal} tentative sans réponse. Que faire ?',
        actions: {
          visit: 'Passer en visite terrain',
          tomorrow: 'Réessayer demain',
          keep: 'Garder dans la file aujourd’hui',
          remove: 'Retirer de la prospection',
        },
        ordinal: {
          one: '1re',
          two: '2e',
          three: '3e',
          other: '{n}e',
        },
        confirm: 'Confirmer',
        saving: 'Enregistrement…',
        saveError: 'Enregistrement impossible : {error}',
      },
      when: {
        inOneHour: 'Dans 1 h · {time}',
        afternoon: 'Cet après-midi · {time}',
        tomorrow: 'Demain · {time}',
        weekday: '{day} · {time}',
        other: 'Autre date…',
        dateLabel: 'Date',
        pickDay: 'Choisir un jour',
        timeLabel: 'Heure',
        timePlaceholder: '10:30',
        timeInvalid: 'Heure sur 24 h, ex. 14:30',
        timePast: 'Ce moment est passé.',
        otherHint: 'Le rappel se place dans la liste d’appels du {day}, à {time}.',
        today: 'aujourd’hui à {time}',
        tomorrowAt: 'demain à {time}',
        onDay: 'le {day} à {time}',
      },
      confirmed: {
        recorded: 'C’est noté : l’appel avec {company} est enregistré.',
        visit: 'C’est noté : visite chez {company} à placer dans votre planning d’ici le {date}.',
        callback: 'C’est noté : rappel de {company} {when}.',
        not_interested: 'C’est noté : {company} n’est pas intéressé, il sort de la prospection.',
        retry: 'C’est noté : nouvel essai {when} (tentative {n} sur 3).',
        visit_after_no_answer: 'C’est noté : {company} devient une visite terrain, à placer dans votre planning d’ici le {date}.',
        retry_tomorrow: 'C’est noté : nouvel essai {when}.',
        kept: 'C’est noté : {company} reste dans la file d’aujourd’hui.',
        removed: 'C’est noté : {company} est retiré de la prospection.',
      },
      addProspect: {
        title: 'Ajouter un prospect',
        subtitle: 'Il rejoint votre liste d’appels du jour.',
        close: 'Fermer',
        search: {
          label: 'Entreprise *',
          placeholder: 'Nom commercial ou SIRET',
          hint: 'Nom commercial ou SIRET (14 chiffres)',
          loading: 'Recherche en cours',
          rateLimited: 'Trop de recherches, réessayez dans un instant.',
          unavailable: 'Annuaire indisponible.',
          empty: 'Aucune entreprise trouvée.',
          resultLine: 'SIRET {siret} · {city}',
          alreadyIn: 'déjà dans Jobbiz',
          footer: 'Annuaire officiel des entreprises',
          manual: 'Saisir à la main',
        },
        followed: {
          banner: 'Cette entreprise est déjà dans Jobbiz : {name} ({city}) est suivie par {firstname} depuis le {date}.',
          bannerSelf: 'Cette entreprise est déjà dans vos prospects : {name} ({city}), depuis le {date}.',
          bannerClient: 'Cette entreprise est déjà dans Jobbiz : {name} ({city}).',
          text: 'Vous pouvez ouvrir sa fiche, ou demander à {firstname} de vous la confier.',
          textOpen: 'Vous pouvez ouvrir sa fiche.',
          open: 'Voir la fiche',
        },
        company: {
          change: 'Changer',
          manualLine: 'Saisie à la main',
          nameLabel: 'Entreprise *',
          nameRequired: 'Le nom est obligatoire.',
        },
        address: {
          label: 'Adresse',
          hint: 'Pré-remplie depuis le SIRET, modifiable',
        },
        phone: {
          label: 'Téléphone *',
          placeholder: '0696 12 34 56',
        },
        phoneErrors: {
          required: 'Le numéro est obligatoire.',
          international: 'Numéro international incomplet ou inconnu.',
          leadingZero: 'Le numéro commence par 0, ex. 0696 12 34 56',
          tooShort: 'Numéro incomplet : 10 chiffres attendus, ex. 0696 12 34 56',
          tooLong: 'Numéro trop long : 10 chiffres attendus, ex. 0696 12 34 56',
        },
        contacts: {
          title: 'Contacts',
          optional: 'facultatif',
          add: 'Ajouter un contact',
          addAnother: 'Ajouter un autre contact',
          card: 'Contact {n}',
          remove: 'Retirer ce contact',
          name: 'Prénom et nom',
          position: 'Poste',
          phone: 'Téléphone direct',
          email: 'E-mail',
          emailPlaceholder: 'prenom.nom@entreprise.fr',
          adminHint: 'Celui de l’administrateur du futur compte Jobbiz',
        },
        sector: {
          label: 'Secteur',
          placeholder: 'Choisir le secteur…',
          hint: 'Il fixe la grille de coefficients de facturation.',
        },
        sectors: {
          retail: 'Grande distribution / Vente',
          hospitality: 'CHR',
          industry: 'Industrie',
          logistics: 'Logistique',
          automotive: 'Automobile',
          temp_transport: 'Intérim - transport',
          other: 'Autre',
        },
        source: {
          label: 'Comment l’avez-vous trouvé ?',
        },
        today: 'Ajouter à ma liste d’appels d’aujourd’hui',
        cancel: 'Annuler',
        submit: 'Ajouter le prospect',
        submitting: 'Ajout…',
        added: 'Prospect ajouté',
        failed: 'Ajout impossible : {error}',
      },
      errors: {
        generic: 'Une erreur est survenue, réessayez.',
        INVALID_ID: 'Identifiant invalide.',
        INVALID_CALLBACK: 'Ce rappel est invalide.',
        PROSPECT_FORBIDDEN: 'Ce prospect ne vous est pas attribué.',
        CALLBACK_FORBIDDEN: 'Ce rappel ne vous est pas attribué.',
        SESSION_FORBIDDEN: 'Cette session d’appels n’est pas la vôtre.',
        FORBIDDEN_ROLE: 'Votre rôle ne donne pas accès à la prospection.',
        PROSPECT_NOT_FOUND: 'Ce prospect est introuvable.',
        CALLBACK_NOT_FOUND: 'Ce rappel est introuvable.',
        PROSPECT_NOT_ACTIVE: 'Ce prospect n’est plus actif.',
        CALLBACK_ALREADY_DONE: 'Ce rappel a déjà été passé.',
        INVALID_PROSPECT_FIELD: 'Un champ du prospect est invalide.',
        INVALID_PHONE: 'Ce numéro de téléphone est invalide.',
        INVALID_SIRET: 'Ce SIRET est invalide.',
        SIRET_ALREADY_FOLLOWED: 'Cette entreprise est déjà dans Jobbiz.',
        INVALID_ASSIGNEE: 'Ce commercial ne peut pas suivre ce prospect.',
        SESSION_NOT_FOUND: 'Cette session d’appels est introuvable.',
        INVALID_CALL_RESULT: 'Ce résultat d’appel est invalide.',
        NOTE_REQUIRED: 'La note est obligatoire.',
        INVALID_FOLLOW_UP: 'La suite de l’appel est invalide.',
        FOLLOW_UP_IN_PAST: 'Ce moment est passé.',
        INTERNAL_ERROR: 'Erreur du serveur, réessayez dans un instant.',
        TOKEN_INVALID_OR_EXPIRED: 'Votre session a expiré, reconnectez-vous.',
      },
    },
    tasks: {
      tabTodo: 'À faire',
      tabDone: 'Terminées',
      search: 'Rechercher',
      filter: 'Filtrer',
      add: 'Ajouter',
      addTooltip: 'Nouvelle tâche · touche N',
      columnTask: 'Tâche',
      columnType: 'Type',
      columnCompany: 'Entreprise',
      columnDue: 'Échéance',
      columnTime: 'Heure',
      columnAssignee: 'Attribuée à',
      groupLate: 'En retard',
      groupToday: 'Aujourd’hui',
      groupTomorrow: 'Demain',
      groupLater: 'Plus tard',
      groupDone: 'Terminées',
      openCompany: 'Ouvrir la fiche',
      moreLinks: '+{count}',
      unread: 'Nouveau commentaire',
      today: 'Aujourd’hui',
      tomorrow: 'Demain',
      yesterday: 'Hier, {day}',
      doneOn: 'Faite {day}',
      appointment: 'Rendez-vous',
      rowTask: 'Tâche',
      rowAppointment: 'Rendez-vous',
      rowCallback: 'Rappel',
      markDone: 'Marquer comme terminé',
      markUndone: 'Marquer à faire',
      doneTask: 'Tâche terminée',
      reopenTask: 'Tâche rouverte',
      doneAppointment: 'Rendez-vous effectué',
      reopenAppointment: 'Rendez-vous rouvert',
      doneCallback: 'Rappel effectué',
      reopenCallback: 'Rappel rouvert',
      undo: 'Annuler',
      assigned: 'Tâche attribuée à {name}',
      movedToday: 'Tâche déplacée à aujourd’hui',
      movedTomorrow: 'Tâche déplacée à demain',
      movedLater: 'Tâche déplacée dans une semaine',
      emptyFilteredTitle: 'Aucune tâche trouvée',
      emptyFilteredText: 'Aucune tâche ne correspond à votre recherche ou à vos filtres.',
      emptyTodoTitle: 'Aucune tâche à faire',
      emptyTodoText: 'Vous n’avez pas de tâche à faire pour le moment, celles qui vous sont attribuées s’afficheront ici.',
      emptyDoneTitle: 'Aucune tâche terminée',
      emptyDoneText: 'Vous n’avez pas encore terminé de tâche, celles que vous cochez s’afficheront ici.',
      filterDue: 'Échéance',
      filterTypes: 'Type',
      filterDay: 'Un jour précis',
      dueLate: 'En retard',
      dueToday: 'Aujourd’hui',
      dueTomorrow: 'Demain',
      dueWeek: 'Cette semaine',
      dueNext: 'Semaine prochaine',
      dueLater: 'Plus tard',
      kanbanAdd: 'Ajouter une tâche',
      kanbanDrop: 'Déposer ici',
      loadError: 'Les tâches n’ont pas pu se charger.',
      retry: 'Réessayer',
      comingSoon: 'Un rappel s’ouvre dans le mode prospection, à venir dans app.admin.',
      peopleTeam: 'Toute l’équipe',
      peopleMe: '{name} (moi)',
      peopleMeShort: 'moi',
      titleMine: 'Mes tâches',
      titlePeople: 'Tâches de {names}',
      titleTeam: 'Tâches de toute l’équipe',
      titleMe: 'moi',
      kanbanDoneOn: 'Terminée {day}',
      errors: {
        INVALID_ID: 'Identifiant invalide.',
        INVALID_PEOPLE: 'Cette sélection de personnes n’est pas valide.',
        INVALID_TASK_FIELD: 'Un champ de la tâche n’est pas valide.',
        INVALID_TASK_TYPE: 'Ce type de tâche n’existe pas.',
        INVALID_DUE_ON: 'L’échéance n’est pas une date valide.',
        INVALID_DUE_TIME: 'L’heure n’est pas valide.',
        INVALID_DURATION: 'La durée doit être comprise entre 5 min et 8 h.',
        TASK_TITLE_REQUIRED: 'Ajoutez un titre ou une description.',
        TASK_TARGET_REQUIRED: 'Un appel ou un e-mail demande une entreprise, un groupe ou un contact.',
        UNKNOWN_COMPANY: 'Cette entreprise n’existe plus.',
        UNKNOWN_GROUP: 'Ce groupe n’existe plus.',
        INVALID_ASSIGNEE: 'Cette personne ne peut pas recevoir de tâche.',
        TEAM_VIEW_FORBIDDEN: 'Seul un responsable d’agence voit les tâches de l’équipe.',
        TASK_FORBIDDEN: 'Vous n’avez pas accès à cette tâche.',
        TASK_WRITE_FORBIDDEN: 'Vous ne pouvez pas modifier cette tâche.',
        TASK_REASSIGN_FORBIDDEN: 'Seuls son créateur et un responsable d’agence peuvent réattribuer cette tâche.',
        TASK_DELETE_FORBIDDEN: 'Seuls son créateur et un responsable d’agence peuvent supprimer cette tâche.',
        TASK_NOT_FOUND: 'Cette tâche n’existe plus.',
        COMMENT_BODY_REQUIRED: 'Le commentaire est vide.',
        COMMENT_TOO_LONG: 'Le commentaire dépasse 5 000 caractères.',
        INVALID_MENTIONS: 'Un collègue identifié ne peut pas l’être.',
        FORBIDDEN_ROLE: 'Votre rôle ne donne pas accès aux tâches.',
        TASK_NOT_EMAIL: 'Cette tâche n’est pas un e-mail.',
        TASK_ALREADY_DONE: 'Cette tâche est déjà faite.',
        TASK_EMAIL_NO_COMPANY: 'Rattachez la tâche à une entreprise pour envoyer l’e-mail.',
        TASK_EMAIL_NO_ADDRESS: 'Le contact n’a pas d’adresse e-mail valide.',
        TASK_EMAIL_NOT_READY: 'Ajoutez un objet et un message avant d’envoyer.',
        EMAIL_SENDING_DISABLED: 'L’envoi d’e-mails est coupé sur cet environnement.',
        EMAIL_SEND_FAILED: 'L’e-mail n’est pas parti. Réessayez dans un instant.',
        INVALID_NOTE: 'Note invalide.',
        INVALID_ORIGIN: 'Origine invalide.',
        APPOINTMENT_NOT_FOUND: 'Ce rendez-vous n’existe plus.',
        APPOINTMENT_FORBIDDEN: 'Vous ne pouvez pas modifier ce rendez-vous.',
        INVALID_APPOINTMENT_TIME: 'Ce créneau n’est pas valide.',
        INVALID_OWNER: 'Cette personne n’a pas d’agenda dans le CRM.',
        APPOINTMENT_DETAILS_LOCKED: 'Ce rendez-vous est organisé par quelqu’un d’autre dans Google Agenda : son titre, sa description, son lieu et son créneau ne se modifient pas ici.',
        INVALID_APPOINTMENT_FIELD: 'Un champ du rendez-vous n’est pas valide.',
        INVALID_CATEGORY: 'Cette catégorie n’existe pas.',
        INVALID_STATUS: 'Ce statut n’existe pas.',
        INVALID_PLANNING_RANGE: 'Cette période n’est pas valide.',
        PLANNING_FORBIDDEN: 'Seul un responsable d’agence consulte le planning d’un collègue.',
        INTERNAL_ERROR: 'Une erreur est survenue. Réessayez.',
        default: 'Une erreur est survenue. Réessayez.',
      },
    },
    companies: {
      tabProspects: 'Prospects',
      tabNew: 'Nouvelles',
      tabOld: 'Anciennes',
      tabLost: 'Perdus',
      search: 'Rechercher une entreprise',
      filter: 'Filtrer',
      add: 'Ajouter',
      openGroup: 'Ouvrir le groupe',
      columnCompany: 'Entreprise',
      columnDepartment: 'Département',
      columnCategory: 'Catégorie',
      columnGroup: 'Groupe',
      columnAction: 'Action à faire',
      columnCreated: 'Créé le',
      columnClientSince: 'Client depuis',
      columnRecruiter: 'Recrutement',
      columnCommercial: 'Commercial',
      columnReason: 'Motif',
      columnRelaunch: 'Relance prévue',
      columnLostOn: 'Perdu le',
      reasonTooltip: 'Résumé par l’IA à partir des échanges',
      loading: 'Chargement des entreprises',
      createdOn: 'Créé le {day}',
      actionCallback: 'Rappel {when}',
      relaunchIn: 'Relancer en {month}',
      noRelaunch: 'Aucune relance',
      assignCommercial: 'Attribuer un commercial',
      assignRecruiter: 'Attribuer un chargé de recrutement',
      commercialAssigned: '{company} attribuée à {name}',
      recruiterAssigned: '{name} suit le recrutement de {company}',
      me: '{name} (moi)',
      filterDepartment: 'Département',
      filterCategory: 'Catégorie',
      filterAction: 'Action à faire',
      filterCommercial: 'Commercial',
      filterSupplier: 'Fournisseur',
      filterMissions: 'Nombre de missions',
      filterPay: 'Conditions de rémunération',
      pickDepartment: 'Sélectionner un département',
      noDepartment: 'Sans département',
      allCategories: 'Toutes les catégories',
      actionWith: 'Avec une action à faire',
      actionWithout: 'Sans action à faire',
      missionsNone: 'Aucune mission',
      missionsAtLeast: 'Au moins un nombre de missions',
      missionsMin: 'Nombre minimum de missions',
      missionsAtLeastCount: 'Au moins {count} mission(s)',
      payIncomplete: 'Conditions incomplètes',
      payIncompleteDetail: 'Heures de nuit, heures supplémentaires, dimanches ou jours fériés à renseigner',
      emptyFilteredTitle: 'Aucune entreprise trouvée',
      emptyFilteredText: 'Aucune entreprise de cet onglet ne correspond à votre recherche ou à vos filtres.',
      emptyTitle: 'Aucune entreprise dans cet onglet',
      empty_prospects: 'Les entreprises à démarcher s’afficheront ici.',
      empty_new: 'Les entreprises devenues clientes depuis moins de 90 jours s’afficheront ici.',
      empty_old: 'Les entreprises clientes depuis plus de 90 jours s’afficheront ici.',
      empty_lost: 'Les prospects et les clients perdus s’afficheront ici, avec le motif et la relance prévue.',
      loadError: 'Les entreprises n’ont pas pu se charger.',
      retry: 'Réessayer',
    },
    viewToggle: {
      list: 'Vue liste',
      kanban: 'Vue kanban',
    },
    record: {
      someone: 'Quelqu’un',
      companyMissing: 'Cette entreprise n’existe plus',
      groupMissing: 'Ce groupe n’existe plus',
      contactMissing: 'Ce contact n’est plus dans la fiche',
      backCompanies: 'Entreprises',
      comingSoon: 'Disponible avec la liste d’appels et le mode prospection, à venir dans app.admin.',
      stageClient: 'Entreprise passée en client',
      stageProspect: 'Entreprise remise en prospect',
      resent: 'Invitation renvoyée à {email}',
      planTask: 'Planifier une tâche',
      planMeeting: 'Prendre un RDV',
      openTask: 'Ouvrir la tâche',
      postpone: 'Reporter',
      call: 'Appeler',
      outcome: 'Saisir l’issue',
      fieldLegalName: 'Raison sociale',
      fieldGroup: 'Groupe',
      fieldAddress: 'Adresse',
      fieldSiret: 'SIRET',
      fieldSupplier: 'Plateforme intérim',
      noSupplier: 'Aucune plateforme',
      fieldApe: 'Code APE',
      fieldLegalForm: 'Forme juridique',
      fieldStaff: 'Effectif',
      staff: '{count} salariés',
      fieldCapital: 'Capital social',
      fieldAgreement: 'Convention collective',
      fieldCategory: 'Catégorie',
      fieldClientSince: 'Client depuis',
      fieldCreated: 'Créée le',
      fieldCommercial: 'Commercial',
      actions: 'Actions',
      editCompany: 'Modifier l’entreprise',
      toClient: 'Passer en client',
      markLost: 'Marquer comme perdu',
      toProspect: 'Remettre en prospect',
      toGroup: 'Transformer en groupe',
      deleteCompany: 'Supprimer l’entreprise',
      addToCalls: 'Ajouter à ma liste d’appels du jour',
      stage_prospect: 'Prospect',
      stage_client: 'Client',
      stage_lost: 'Perdu',
      number: 'N° {number}',
      inGroup: 'Groupe {name}',
      actionNote: 'Note',
      actionEmail: 'E-mail',
      actionCall: 'Appel',
      noPhone: 'Aucun numéro de téléphone à appeler.',
      actionTask: 'Tâche',
      actionMeeting: 'RDV',
      actionMore: 'Plus',
      actionContact: 'Contact',
      addContact: 'Ajouter un contact',
      nextAction: 'Prochaine action',
      noNextAction: 'Aucune action prévue',
      about: 'À propos',
      seeMore: 'Voir plus',
      seeLess: 'Voir moins',
      tab_overview: 'Vue d’ensemble',
      tab_activity: 'Activité',
      tab_contacts: 'Contacts',
      tab_missions: 'Missions',
      tab_billing: 'Facturation',
      tab_pay: 'Conditions de rému.',
      since: 'depuis le {day}',
      upcoming: 'À venir',
      upcomingEmptyTitle: 'Rien de prévu',
      upcomingEmptyText: 'Les rendez-vous, tâches et rappels à venir s’afficheront ici.',
      recent: 'Derniers échanges',
      recentEmptyTitle: 'Aucun échange',
      recentEmptyText: 'Les derniers appels, e-mails et notes s’afficheront ici.',
      kpiMissions: 'Missions en cours',
      kpiToFillOne: '{count} mission à pourvoir',
      kpiToFillMany: '{count} missions à pourvoir',
      kpiAllFilled: 'Toutes pourvues',
      kpiRevenue: 'CA 12 derniers mois',
      kpiGrowth: '{growth} % vs N-1',
      kpiFirstYear: 'Première année',
      kpiNotClient: 'Pas encore client',
      kpiNoInvoices: 'Factures non visibles avec votre accès',
      kpiLoading: 'Calcul en cours…',
      kpiUnpaid: 'Factures impayées',
      kpiUnpaidOne: '{count} facture en attente',
      kpiUnpaidMany: '{count} factures en attente',
      kpiNoDelay: 'Aucun retard',
      nextWhen: '{day} à {time}',
      today: 'Aujourd’hui',
      nextCallback: 'Rappeler {name}',
      switchboard: 'le standard',
      nextMeeting: 'Rendez-vous avec {name}',
      nextMeetingAlone: 'Rendez-vous',
      results: 'Résultats',
      resultsHeldOne: 'RDV réalisé',
      resultsHeldMany: 'RDV réalisés',
      resultsRequestsOne: 'Demande entrante',
      resultsRequestsMany: 'Demandes entrantes',
      resultsSalesOne: 'Vente signée',
      resultsSalesMany: 'Ventes signées',
      resultsRevenue: 'CA généré',
      resultsShowUp: 'Show-up',
      resultsClosing: 'Closing',
      ambassador: 'Ambassadeur',
      pending: 'Invitation en attente',
      access: 'Accès {role}',
      contactsCount: 'Contacts ({count})',
      contactsEmptyTitle: 'Aucun contact',
      contactsEmptyText: 'Ajoutez les personnes à qui vous parlez dans cette entreprise : leur poste, leur téléphone, leur e-mail.',
      registered: 'Inscrits sur Jobbiz · {count}',
      notRegistered: 'Non inscrits sur Jobbiz · {count}',
      resend: 'Renvoyer l’invitation',
      invite: 'Inviter',
      groupContacts: 'Contacts du groupe ({count})',
      groupContactsEmpty: 'La RRH, les achats ou la direction du groupe s’ajoutent sur sa fiche.',
      missionsTab: 'Mission',
      workersTab: 'Intérimaire',
      createMission: 'Créer une mission',
      pickCompanyTitle: 'Pour quelle entreprise ?',
      pickCompanySearch: 'Rechercher une entreprise',
      pickCompanyEmpty: 'Aucune entreprise ne correspond.',
      missionsEmptyTitle: 'Aucune mission',
      missionsEmptyText: 'Les missions que l’entreprise crée sur Jobbiz s’afficheront ici, en cours, à venir puis terminées.',
      missions_current: 'En cours',
      missions_upcoming: 'À venir',
      missions_done: 'Terminées',
      noWorker: 'Aucun intérimaire attribué',
      workersEmptyTitle: 'Aucun intérimaire',
      workersEmptyText: 'Les intérimaires passés par cette entreprise s’afficheront ici, avec l’avis qu’elle leur a laissé.',
      workerMissionsOne: '{count} mission effectuée',
      workerMissionsMany: '{count} missions effectuées',
      notRated: 'Pas encore noté',
      workers_positive: 'Bien notés',
      workers_mixed: 'Avis partagés',
      workers_negative: 'Mal notés',
      workers_notRated: 'Pas encore notés',
      groupAlone: 'Le groupe seul',
      group: 'Groupe',
      companiesOne: '{count} entreprise',
      companiesMany: '{count} entreprises',
      clientsOne: '{count} cliente',
      clientsMany: '{count} clientes',
      groupContactsTitle: 'Contacts du groupe ({count})',
      add: 'Ajouter',
      noPosition: 'Poste non renseigné',
      allContacts: 'Voir tous les contacts',
      groupCompanies: 'Entreprises du groupe ({count})',
      addCompany: 'Ajouter une entreprise',
      groupCompaniesEmptyTitle: 'Aucune entreprise dans ce groupe',
      groupCompaniesEmptyText: 'Ajoutez-en une avec le bouton ci-dessus.',
      groupCompaniesRange: '{from} à {to} sur {count} entreprises',
      groupBillingNoCompany: 'Ajoutez une entreprise au groupe depuis sa vue d’ensemble : ses factures s’afficheront ici.',
      noDepartment: 'Département non renseigné',
      missionsOne: '{count} mission',
      missionsMany: '{count} missions',
      lastExchange: 'Échange le {day}',
      noExchange: 'Aucun échange',
      groupUpcomingEmptyText: 'Les rendez-vous, tâches et rappels du groupe et de ses entreprises s’afficheront ici.',
      groupRecentEmptyText: 'Les derniers appels, e-mails et notes du groupe et de ses entreprises s’afficheront ici.',
      groupAndCompanies: 'Le groupe et ses entreprises',
      groupContactsEmptyTitle: 'Personne au niveau du groupe',
      groupContactsEmptyText: 'Ajoutez ceux qui décident pour toutes les entreprises : la RRH, les achats, la direction.',
      editContact: 'Modifier {name}',
      contactsOne: '{count} contact',
      contactsMany: '{count} contacts',
      companyNoContact: 'Aucun contact dans cette entreprise.',
      workingFor: '{count} entreprises',
      information: 'Informations',
      fieldEmail: 'E-mail',
      fieldPhone: 'Téléphone',
      fieldLead: 'Statut du lead · pour toutes ses entreprises',
      lead_none: 'Rien',
      lead_ambassadeur: 'Ambassadeur',
      ambassadorSet: '{name} ambassadeur',
      ambassadorUnset: 'Statut retiré',
      groupContact: 'Contact du groupe',
      notOnJobbiz: 'Non inscrit sur Jobbiz',
      places: 'Entreprises ({count})',
      placesWithGroups: 'Groupes et entreprises ({count})',
      inviteAt: 'Inviter sur Jobbiz chez {company}',
    },
    mailComposer: {
      newMessage: 'Nouveau message',
      minimize: 'Réduire',
      restore: 'Rouvrir',
      expand: 'Plein écran',
      shrink: 'Quitter le plein écran',
      close: 'Fermer',
      to: 'À',
      cc: 'Cc',
      bcc: 'Cci',
      subject: 'Objet',
      message: 'Message',
      send: 'Envoyer',
      discard: 'Supprimer le brouillon',
      demoHint: 'Démo : l’e-mail s’ajoute à l’activité sans partir.',
      scheduleTitle: 'Programmer l’envoi',
      slot_tomorrowMorning: 'Demain matin',
      slot_tomorrowAfternoon: 'Demain après-midi',
      slot_mondayMorning: 'Lundi matin',
      slot_custom: 'Choisir une date et une heure',
      timeLabel: 'Heure',
      schedulePast: 'Choisissez un moment à venir.',
      back: 'Retour',
      scheduleCta: 'Programmer l’envoi',
      sentToast: 'E-mail ajouté à l’activité',
      scheduledToast: 'Envoi programmé le {day} à {time}',
    },
    recordActivity: {
      emailScheduled: 'E-mail programmé pour {address}',
      cancelSend: 'Annuler l’envoi',
      sendCanceled: 'Envoi annulé',
      callBy: 'Appel de {name}',
      callResult: {
        answered: 'Contact joint.',
        callback: 'À rappeler.',
        no_answer: 'Sans réponse.',
        not_interested: 'Pas intéressé.',
      },
      emailTo: 'E-mail envoyé à {address}',
      emailFrom: 'E-mail reçu de {address}',
      emailHeaderSent: 'De : {from} · À : {to} ({address})',
      emailHeaderReceived: 'De : {from} · À : {to}',
      meetingWith: 'Rendez-vous avec {name}',
      meeting: 'Rendez-vous',
      taskDoneBy: 'Tâche terminée par {name}',
      taskFor: 'Tâche attribuée à {name}',
      taskDue: 'Échéance : {day}',
      noteBy: 'Note de {name}',
      client: {
        mission_created: 'a créé la mission n° {number} · {title}',
        mission_canceled: 'a annulé la mission n° {number} · {title}',
        contract_signed: 'a signé le contrat de {worker} · mission n° {number}',
        timesheet_validated: 'a validé le relevé d’heures de {worker} · {hours} h',
        worker_review_positive: 'a laissé un avis positif sur {worker} · {job}',
        worker_review_negative: 'a laissé un avis négatif sur {worker} · {job}',
        member_added: 'a ajouté {member} à l’espace entreprise',
      },
      clientMany: {
        mission_created: '{count} missions créées',
        mission_canceled: '{count} missions annulées',
        contract_signed: '{count} contrats signés',
        timesheet_validated: '{count} relevés d’heures validés',
        worker_review: '{count} avis laissés',
        member_added: '{count} membres ajoutés',
      },
      clientBy: 'par {who}',
      people: '{count} personnes',
      more: 'Voir plus',
      less: 'Voir moins',
      seeAll: 'Voir les {count}',
      unread: 'Pas encore lu',
      readOnce: 'Lu une fois · dernière lecture {day} à {time}',
      readMany: 'Lu {count} fois · dernière lecture {day} à {time}',
      subject: 'Objet : {subject}',
      filter_all: 'Tout',
      filter_email: 'E-mails',
      filter_call: 'Appels',
      filter_task: 'Tâches',
      filter_note: 'Notes',
      filter_client: 'Actions clients',
      add: 'Ajouter',
      addTask: 'Une tâche',
      addEvent: 'Un rendez-vous',
      upcoming: 'À venir',
      empty_all: 'Aucune activité',
      empty_email: 'Aucun e-mail',
      empty_call: 'Aucun appel',
      empty_task: 'Aucune tâche',
      empty_note: 'Aucune note',
      empty_client: 'Aucune action du client',
      emptyText_all: 'Les appels, e-mails, rendez-vous, tâches et notes s’afficheront ici, du plus récent au plus ancien.',
      emptyText_email: 'Les e-mails envoyés et reçus s’afficheront ici, avec le nombre de lectures de chacun.',
      emptyText_call: 'Les appels notés s’afficheront ici.',
      emptyText_task: 'Les tâches et les rendez-vous s’afficheront ici, à venir puis faits.',
      emptyText_note: 'Les notes prises sur la fiche s’afficheront ici.',
      emptyText_client: 'Ce que le client fait dans Jobbiz s’affichera ici.',
    },
    recordForm: {
      close: 'Fermer',
      cancel: 'Annuler',
      noteTitle: 'Ajouter une note',
      noteCta: 'Ajouter la note',
      noteLabel: 'Note',
      notePlaceholder: 'Ce qu’il faut retenir…',
      noteSaved: 'Note ajoutée',
      callTitle: 'Appeler {name}',
      callCta: 'Enregistrer l’appel',
      callHintOne: '{company} : appelez, puis notez le résultat de l’appel.',
      callHintMany: 'Choisissez qui appeler, puis notez le résultat de l’appel.',
      who: 'Qui',
      resultLabel: 'Résultat',
      result_answered: 'Contact joint',
      result_callback: 'À rappeler',
      result_no_answer: 'Sans réponse',
      result_not_interested: 'Pas intéressé',
      callNote: 'Note',
      callNotePlaceholder: 'Ce qu’il faut retenir de l’échange…',
      callSaved: 'Appel enregistré',
      eventTitle: 'Ajouter un rendez-vous',
      eventCta: 'Ajouter le rendez-vous',
      eventWhat: 'Objet',
      eventWhatPlaceholder: 'Bilan du trimestre et besoins pour décembre',
      day: 'Date',
      time: 'Heure',
      timeError: 'Heure sur 24 h, par exemple 14:30',
      duration: 'Durée',
      duration_30: '30 min',
      duration_45: '45 min',
      duration_60: '1 h',
      duration_90: '1 h 30',
      duration_120: '2 h',
      location: 'Lieu',
      locationPlaceholder: 'Adresse du rendez-vous',
      onSite: 'Sur place',
      with: 'Avec',
      description: 'Description',
      eventSaved: 'Rendez-vous ajouté',
      lostTitle: 'Marquer comme perdu',
      lostCta: 'Marquer comme perdu',
      reason: 'Motif',
      reason_price: 'Prix trop élevé',
      reason_competitor: 'A choisi une autre agence',
      reason_noNeed: 'Pas de besoin avant la saison',
      reason_direct: 'Recrute en direct',
      reason_unreachable: 'Injoignable',
      reason_closed: 'Établissement fermé',
      reasonDetails: 'Précisions',
      relaunch: 'Relance prévue',
      noRelaunch: 'Aucune relance',
      lostSaved: 'Entreprise marquée comme perdue',
      deleteTitle: 'Supprimer l’entreprise',
      deleteCta: 'Supprimer',
      deleteWarning: 'Seul un prospect peut être supprimé : il disparaît de la liste des entreprises.',
      deleteReason: 'Motif de la suppression',
      deleteReasonPlaceholder: 'Choisir un motif',
      deleteReason_duplicate: 'Doublon d’une autre entreprise',
      deleteReason_test: 'Inscription de test',
      deleteReason_spam: 'Fausse inscription',
      deleteReason_outOfScope: 'Hors cible (ne recrute pas d’intérimaires)',
      deleteReason_other: 'Autre',
      deleteDetailsRequired: 'Précisez le motif',
      deleteSaved: 'Entreprise supprimée',
      toGroupTitle: 'Transformer en groupe',
      toGroupCta: 'Créer le groupe',
      groupName: 'Nom du groupe',
      toGroupHint: 'Un groupe portant ce nom est créé, et l’entreprise y est rattachée.',
      toGroupSaved: 'Groupe créé',
      contactAddTitle: 'Ajouter un contact au groupe',
      contactEditTitle: 'Modifier le contact',
      contactCta: 'Enregistrer',
      firstname: 'Prénom',
      lastname: 'Nom',
      position: 'Poste',
      phone: 'Téléphone',
      email: 'E-mail',
      contactSaved: 'Contact enregistré',
      groupCompanyTitle: 'Ajouter une entreprise au groupe',
      searchCompany: 'Rechercher une entreprise',
      groupCompanyCta: 'Ajouter',
      groupCompanySaved: '{company} ajoutée au groupe {group}',
      groupCompanyNone: 'Aucune entreprise hors groupe ne correspond.',
    },
    assign: {
      unassigned: 'Non assigné',
      tooltip: 'Attribuer',
      me: '{name} (moi)',
    },
    comments: {
      emptyTitle: 'Aucun commentaire',
      emptyText: 'Posez une question ou dites où vous en êtes ; tapez @ pour identifier un collègue.',
      placeholder: 'Ajouter un commentaire… @ pour identifier un collègue',
      submit: 'Commenter',
      at: '{day} à {time}',
      someone: 'Quelqu’un',
      added: 'Commentaire ajouté',
      sentWithMentionsOne: 'Commentaire envoyé, {names} est identifié',
      sentWithMentionsOther: 'Commentaire envoyé, {names} sont identifiés',
    },
    activity: {
      at: '{day} à {time}',
    },
    taskActivity: {
      created: 'Tâche créée',
      createdBy: 'Tâche créée par {name}',
      done: 'Marquée comme terminée',
      doneBy: 'Marquée comme terminée par {name}',
      reopened: 'Rouverte',
      reopenedBy: 'Rouverte par {name}',
      updated: 'Modifiée',
      updatedBy: 'Modifiée par {name}',
      empty: 'vide',
      someone: 'quelqu’un',
      otherCompany: 'une autre entreprise',
      field_title: 'Titre',
      field_type: 'Type',
      field_note: 'Description',
      field_dueOn: 'Échéance',
      field_dueTime: 'Heure',
      field_durationMin: 'Durée',
      field_assigneeId: 'Attribuée à',
      field_companyId: 'Entreprise',
      field_contactName: 'Contact',
      field_emailTemplate: 'Modèle d’e-mail',
      field_emailSubject: 'Objet',
      field_emailBody: 'Message',
    },
    taskPanel: {
      close: 'Fermer',
      loadError: 'Cette tâche n’a pas pu se charger.',
      tabDetail: 'Détail',
      tabActivity: 'Activité',
      tabComments: 'Commentaires',
      fiche: 'Fiche',
      linkKind_company: 'Entreprise',
      linkKind_group: 'Groupe',
      linkKind_contact: 'Contact',
      linkKind_tempWorker: 'Intérimaire',
      linkNotValidated: 'Non validé',
      descriptionLabel: 'Description de la tâche',
      descriptionPlaceholder: 'Décrivez la tâche…',
      descriptionSaved: 'Description enregistrée',
      emailSaved: 'E-mail enregistré',
      assigned: 'Tâche attribuée à {name}',
      done: 'Tâche terminée',
      reopened: 'Tâche rouverte',
      emailSent: 'E-mail envoyé',
      deleted: 'Tâche supprimée',
      undo: 'Annuler',
      edit: 'Modifier la tâche',
      delete: 'Supprimer la tâche',
      markDone: 'Marquer comme terminé',
      reopen: 'Rouvrir la tâche',
      doneOn: 'Faite le {day}',
      call: 'Appeler',
      sendEmail: 'Envoyer l’e-mail',
      emailReady: 'E-mail prêt',
      emailEditButton: 'Modifier',
      emailEdit: 'Modifier l’e-mail',
      emailTemplateLabel: 'Modèle Intercom',
      emailSubjectLabel: 'Objet',
      emailBodyLabel: 'Message',
      emailTemplate: 'Modèle choisi par l’IA : {template}',
      emailNoTemplate: 'à choisir',
      emailAi: 'IA',
      emailTo: 'À : {to}',
      emailTemplateHint: 'Choisi par l’IA à partir de la description, modifiable.',
      emailRemoveAttachment: 'Retirer {name}',
      emailSubject: 'Objet : {subject}',
      emailEmpty: 'Le message n’est pas encore rédigé.',
      cancel: 'Annuler',
      save: 'Enregistrer',
    },
    taskForm: {
      close: 'Fermer',
      newTitle: 'Nouvelle tâche',
      editTitle: 'Modifier la tâche',
      newSubtitle: 'Planifiez une action à faire.',
      createdBy: 'Créée par {name} le {day}',
      titleLabel: 'Titre',
      noteLabel: 'Description',
      titleHint: 'Proposé par l’IA à partir de la description, modifiable.',
      noteHint: 'L’IA en tirera le titre de la tâche.',
      noteHintEmail: 'L’IA en tirera le titre et choisira le modèle d’e-mail.',
      typeLabel: 'Type',
      typeMeeting: 'Rendez-vous',
      typeHint_todo: 'Une action simple à cocher, ajoutée à vos tâches du jour.',
      typeHint_call: 'Pour un prospect, l’appel rejoindra votre liste d’appels de prospection du jour J. Pour un client, il reste une tâche.',
      typeHint_call_noProspect: 'Un appel reste une tâche : il apparaîtra dans vos tâches du jour J.',
      typeHint_email: 'Le jour J, l’e-mail s’ouvrira prêt à envoyer.',
      typeHint_visit: 'Une visite sur place, sans heure fixe si besoin.',
      typeHint_meeting: 'Le rendez-vous s’ajoute à votre planning.',
      typeHelp_todo: 'Une action simple à cocher',
      typeHelp_call: 'Un prospect rejoint la liste d’appels de prospection',
      typeHelp_call_noProspect: 'Un appel qui reste une tâche du jour J',
      typeHelp_email: 'S’ouvre prêt à envoyer, avec un modèle Intercom',
      typeHelp_visit: 'Un passage sur place',
      typeHelp_meeting: 'S’ajoute à votre planning',
      dayLabel: 'Date d’activité',
      timeLabel: 'Heure (facultatif)',
      timeError: 'Heure sur 24 h, par exemple 9:30',
      today: 'Aujourd’hui',
      tomorrow: 'Demain',
      monday: 'Lundi {day}',
      durationLabel: 'Durée',
      duration_15: '15 min',
      duration_30: '30 min',
      duration_45: '45 min',
      duration_60: '1 h',
      duration_90: '1 h 30',
      duration_120: '2 h',
      templateLabel: 'Modèle Intercom',
      templateHint: 'Choisi par l’IA à partir de la description, modifiable.',
      assigneeLabel: 'Activité attribuée à',
      assigneeNobody: 'Personne',
      me: '{name} (moi)',
      linksLabel: 'Fiches liées (facultatif)',
      linksPlaceholder: 'Rechercher un contact, une entreprise, un groupe ou un intérimaire',
      linksHint: 'Autant de fiches que nécessaire : contacts, entreprises, groupes ou intérimaires.',
      linksGroup_company: 'Entreprises',
      linksGroup_group: 'Groupes',
      linksGroup_contact: 'Contacts',
      linksGroup_tempWorker: 'Intérimaires',
      linksNotValidated: 'Non validé',
      linksRemove: 'Retirer {label}',
      contactPlaceholder: 'Rechercher une entreprise ou un contact',
      blockTitle: 'Donnez un titre à la tâche.',
      contactCall: 'Appel au {phone}',
      contactEmail: 'E-mail à {email}',
      contactCallUnknown: 'Appel au numéro inconnu',
      contactEmailUnknown: 'E-mail à adresse inconnue',
      contactChoose: 'Choisir',
      contactPlaceholderScoped: 'Rechercher un contact',
      contactNone: 'Aucune fiche',
      contactNoResult: 'Aucune fiche trouvée.',
      contactScopeCompanyGroup: '{company}, ses contacts et les entreprises du groupe {group}.',
      contactScopeCompany: '{company}, ses contacts.',
      contactScopeGroup: '{group}, ses contacts et ses entreprises.',
      blockDescription: 'Décrivez la tâche.',
      blockCall: 'Choisissez qui appeler.',
      blockEmail: 'Choisissez à qui écrire.',
      blockTime: 'Heure au format 9:30.',
      cancel: 'Annuler',
      save: 'Enregistrer',
      busy: 'Un instant…',
      ctaTodo: 'Ajouter la tâche',
      addedTodo: 'Tâche ajoutée',
      whenTomorrow: ' pour demain',
      whenDay: ' pour {day}',
      handed: 'Tâche attribuée à {name}',
      saved: 'Tâche enregistrée',
      deleted: 'Tâche supprimée',
      duplicated: 'Tâche dupliquée',
      copyOf: '{title} (copie)',
      delete: 'Supprimer',
      duplicate: 'Dupliquer',
    },
    taskTypes: {
      todo: 'Tâche',
      call: 'Appel',
      email: 'E-mail',
      visit: 'Visite',
      meeting: 'Réunion',
    },
    eventCategories: {
      prospection: { label: 'Visite terrain', title: 'Visite terrain' },
      visite_client: { label: 'Visite client', title: 'Visite client' },
      rdv_client: { label: 'RDV client', title: 'Rendez-vous client' },
      embauche: { label: 'Visite embauche', title: 'Visite embauche' },
      presentation: { label: 'Présentation', title: 'Présentation de Jobbiz' },
      telephone: { label: 'Téléphonique', title: 'Rendez-vous téléphonique' },
      interne: { label: 'Interne', title: 'Réunion interne' },
    },
    profil: {
      profil: 'Mon profil',
      account: 'Mon compte',
      knowledge: 'Mon savoir faire',
      proof: 'Mes justificatifs',
      availabilities: 'Mes disponibilités',
      params: 'Paramètres',
    },
    savoir: {
      cv: 'Curriculum Vite',
      exp: 'Expériences',
      skills: 'Compétences',
      lang: 'Languages',
      tools: 'Matériels possédés',
    },
    proof: {
      identity: 'Justificatif d’identité',
      degree: 'Formations',
      licence: 'Permis',
    },
    pennylanePush: {
      alreadyOnPennylane: 'Déjà sur PennyLane',
      skippedCount: '{count} déjà sur PennyLane',
      invoiceSkipped: 'Facture {number} déjà sur PennyLane : rien n’a été envoyé',
    },
    availabilities: {
      myhours: 'Mes horaires',
      dispo: "Périodes d'indisponibilité",
      subtitleH:
        'Indiquez à quelles tranches horaires vous êtes disponible' +
        ' pour travailler.',
      subtitleD: "Indiquez les périodes où vous n'êtes pas du tout disponible.",
    },
    justify: {
      m_vitale_title_c: 'Ajouter une carte vitale',
      m_vitale_title_u: 'Modifier la carte vitale',
      m_vitale_title_d: 'Supprimer une carte vitale',
      m_vitale_d_content:
        'Êtes-vous sûr de vouloir supprimer votre carte' +
        ' vitale ? Cette action est irréversible.',
      m_iban_title_c: 'Ajouter une identité bancaire',
      m_iban_title_u: "Modifier l'identité bancaire",
      m_iban_title_d: 'Supprimer une identité bancaire',
      m_identity_title_c: 'Validation d’identité',
      m_proof_title_c: 'Ajouter un justificatif de domicile',
    },
    slideOverCloseConfirm: {
      addMission:
        'Êtes-vous sûr de vouloir quitter la création de mission ? Les informations saisies seront perdues.',
      addCompany:
        'Êtes-vous sûr de vouloir quitter la création d’entreprise ? Les informations saisies seront perdues.',
      qualification:
        'Êtes-vous sûr de vouloir quitter la qualification ? Les informations non enregistrées seront perdues.',
    },
    missionTasks: {
      titleDe: 'Tâches du {title}',
      titleElided: "Tâches de l'{title}",
    },
    missionDetail: {
      tabs: {
        mission: 'Mission',
        requirements: 'Pré-requis',
        tasks: 'Tâches',
        risk: 'Poste à risque',
      },
      tasks: {
        empty: 'Aucune tâche renseignée pour cette mission.',
        added: 'Ajoutée',
        required: 'Retenez au moins une tâche pour la mission.',
        tooMany: 'Une mission ne peut pas retenir plus de 50 tâches.',
        pending:
          'Une tâche ajoutée est encore en vérification : attendez la fin de la vérification avant de confirmer.',
      },
      risk: {
        empty: 'Aucun facteur de risque renseigné pour cette mission.',
        factorRequired:
          'Sélectionnez au moins un facteur de pénibilité pour un poste à risque.',
      },
      info: {
        contact: 'Responsable',
        contactName: 'Nom',
        contactPoste: 'Poste',
        contactNameRequired: 'Le nom du responsable est obligatoire.',
        contactEmpty: 'Aucun',
        coefficient: 'Coefficient de facturation',
        coefficientUndefined: 'Non défini',
        coefficientFromCompany: 'Valeur entreprise',
        coefficientOverridden: 'Modifié pour cette mission',
        coefficientCompanyValue: '(entreprise : {value})',
        coefficientReset: 'Revenir à la valeur de l’entreprise',
        coefficientEmptyHint:
          'Laissé vide, le coefficient suit la grille de l’entreprise : {value}.',
        coefficientInvalid:
          'Saisissez un coefficient supérieur à 0 et inférieur à 10 (ex. 1,85).',
        coefficientFixBeforeConfirm:
          'Corrigez le coefficient de facturation avant de confirmer.',
      },
      requirements: {
        dressCode: 'Dress code',
        dressCodeEmpty: 'Aucun',
        dressCodeTooLong: 'Le dress code ne peut pas dépasser 500 caractères.',
      },
      changes: {
        dressCode: 'Dress code',
        contact: 'Responsable',
        toolProviders: 'Fournisseurs du matériel',
        tasks: 'Tâches',
        riskyPosition: 'Poste à risque',
        coefficientCompany: 'valeur entreprise',
        contactKeptOnContract:
          "Le contrat déjà généré garde l'ancien responsable.",
      },
    },
    jobbizBackfill: {
      offLabel: 'Jobbiz ne complète pas',
      offTooltip:
        "L'entreprise a désactivé « Jobbiz complète si besoin » : ne pas proposer la mission à d'autres profils ni chercher de remplaçant.",
    },
    toolProviders: {
      verb: {
        company: 'fourni par',
        temp_worker: 'apporté par',
      },
      who: {
        company: "l'entreprise",
        temp_worker: "l'intérimaire",
      },
      switchTo: {
        company: "Passer à « fourni par l'entreprise »",
        temp_worker: "Passer à « apporté par l'intérimaire »",
      },
      providerLabel: 'Fournisseur de {name} : {who}',
      remove: 'Retirer {name}',
      removeTooltip: 'Retirer',
    },
    missionHistory: {
      sameTitle: '{count}x ce poste',
      sameTitleDetail: 'Missions « {title} » déjà réalisées : {count}',
      sameTitleSameCompany: 'Dont chez ce client : {count}',
      lastMission: 'Dernière : {company}, du {start} au {end}',
      sameCompany: '{count}x ce client',
      sameCompanyDetail:
        'Missions déjà réalisées chez ce client, tous postes confondus : {count}',
      conflict: 'Déjà en mission',
      conflictDetail: 'Assigné sur des dates qui chevauchent cette mission :',
      conflictItem: 'N°{number} {title} — {company}, du {start} au {end}',
    },
    invoiceImport: {
      modalTitle: 'Importer les factures de {month}',
      modalText:
        'Les factures non importées et celles en erreur seront récupérées depuis Bestt, puis importées dans Pennylane.',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      confirming: 'Lancement…',
      alreadyRunning: 'Un import de ce mois est déjà en cours : sa progression s’affiche.',
      periodInvalid: 'Ce mois ne peut pas être importé.',
      startFailed: 'L’import n’a pas pu être lancé, réessayez.',
      stepBestt: 'Étape 1/2 · Récupération depuis Bestt',
      stepPennylane: 'Étape 2/2 · Import dans Pennylane',
      fetchedCount: '{done} / {total} factures récupérées',
      importedCount: '{done} / {total} factures importées',
      finished: 'Import terminé',
      finishedWithErrors: 'Import terminé avec des erreurs',
      finishedWithErrorsCount: '{done} / {total} importées · {errors} en erreur',
      failed: 'Import impossible',
      fatal: {
        ERR_BESTT_INDISPONIBLE: 'Bestt ne répond pas : rien n’a été importé. Réessayez plus tard.',
        ERR_PASSAGE_INTERROMPU: 'L’import s’est interrompu. Réessayez : rien ne sera importé en double.',
        generic: 'L’import a échoué. Réessayez.',
      },
      close: 'Fermer',
      bannerTitle: 'Erreur lors de l’importation',
      bannerCountOne: '1 facture n’a pas pu être importée',
      bannerCountMany: '{count} factures n’ont pas pu être importées',
      bannerLastRun: 'dernier import le {date} à {time}',
      bannerLastRunBy: 'dernier import le {date} à {time} par {name}',
      retryAll: 'Tout réessayer',
      nothingToRetry: 'Plus aucune facture en erreur pour ce mois.',
      retryFailed: 'Le réessai n’a pas pu être lancé, réessayez.',
      showJournal: 'Voir le journal',
      showErrors: 'Voir les erreurs',
      tooManyInvoices: 'Trop de factures : utilisez Tout réessayer.',
      journalNothingToRetry: 'Plus aucune de ces factures n’est en erreur.',
      informationSaving: 'Une facture de ce mois est en cours d’enregistrement, réessayez dans un instant.',
      listImportOne: 'Import de 1 facture',
      listImportMany: 'Import de {count} factures',
      bannerLastListRunOne: 'dernier import de 1 facture le {date} à {time}',
      bannerLastListRunOneBy: 'dernier import de 1 facture le {date} à {time} par {name}',
      bannerLastListRunMany: 'dernier import de {count} factures le {date} à {time}',
      bannerLastListRunManyBy: 'dernier import de {count} factures le {date} à {time} par {name}',
    },
    invoiceJournal: {
      title: 'Journal d’import · Bestt → Pennylane',
      close: 'Fermer',
      moreActions: 'Plus d’actions',
      openJournal: 'Journal d’import',
      tabToFix: 'À corriger',
      tabHistory: 'Historique',
      retryAll: 'Tout réessayer ({count})',
      loading: 'Chargement du journal…',
      loadFailed: 'Le journal n’a pas pu être chargé',
      reload: 'Recharger',
      emptyTitle: 'Aucune facture à corriger',
      emptyText: 'Aucune facture de {month} n’est en erreur.',
      headerOne: '1 facture est en erreur. Corrigez sa cause, puis réessayez.',
      headerMany: '{count} factures sont en erreur. Elles sont regroupées par cause : corrigez la cause, puis réessayez.',
      groupBesttOne: '1 facture · bloquée à la récupération depuis Bestt',
      groupBesttMany: '{count} factures · bloquées à la récupération depuis Bestt',
      groupPennylaneOne: '1 facture · bloquée à l’import dans Pennylane',
      groupPennylaneMany: '{count} factures · bloquées à l’import dans Pennylane',
      groupOne: '1 facture',
      groupMany: '{count} factures',
      stepBestt: 'Étape 1 · Bestt',
      stepPennylane: 'Étape 2 · Pennylane',
      showGroup: 'Déplier',
      hideGroup: 'Replier',
      howToFix: 'Comment corriger',
      invoiceLine: 'N° {number} · {company}',
      besttClient: 'Client Bestt {id}',
      viewInvoice: 'Voir la facture',
      pdfComesWithImport: 'Le PDF arrive avec l’import',
      code: 'Code : {code}',
      retryGroupOne: 'Réessayer cette facture',
      retryGroupMany: 'Réessayer ces {count} factures',
      and: ' et ',
      errors: {
        ERR_BESTT_FACTURE_INTROUVABLE: {
          label: 'Facture introuvable dans Bestt',
          explanation: 'Bestt dit ne pas connaître ces factures.',
          fix: 'Vérifiez ces factures dans Bestt, puis réessayez.',
        },
        ERR_BESTT_API: {
          label: 'Bestt n’a pas répondu',
          explanation: 'Bestt a échoué sur ces factures.',
          fix: 'Attendez quelques minutes, puis réessayez.',
        },
        ERR_ENTREPRISE_INCONNUE_JOBBIZ: {
          label: 'Client Bestt sans entreprise Jobbiz',
          explanation: 'Aucune entreprise Jobbiz n’a ce client Bestt.',
          fix: 'Renseignez l’identifiant Bestt dans la fiche de l’entreprise, puis réessayez.',
        },
        ERR_ENTREPRISE_AMBIGUE_JOBBIZ: {
          label: 'Client Bestt rattaché à plusieurs entreprises',
          explanation: 'Plusieurs entreprises Jobbiz ont ce client Bestt.',
          fix: 'Ne laissez cet identifiant Bestt qu’à une seule entreprise, puis réessayez.',
        },
        ERR_BESTT_PDF_INDISPONIBLE: {
          label: 'PDF indisponible dans Bestt',
          explanation: 'Bestt n’a pas rendu le PDF de ces factures.',
          fix: 'Attendez quelques minutes, puis réessayez.',
        },
        ERR_STOCKAGE_PDF: {
          label: 'PDF non enregistré',
          explanation: 'Le PDF de ces factures n’a pas pu être rangé ou relu.',
          fix: 'Attendez quelques minutes, puis réessayez.',
        },
        ERR_PENNYLANE_DESACTIVE: {
          label: 'Envoi à Pennylane désactivé hors production',
          explanation: 'Hors production, rien n’est envoyé à Pennylane.',
          fix: 'Rien à corriger : normal hors production.',
        },
        ERR_ENTREPRISE_INTROUVABLE_PENNYLANE: {
          label: 'Entreprise introuvable dans Pennylane',
          explanation: 'Aucun client Pennylane ne correspond à l’entreprise, et Jobbiz n’a pas pu le créer.',
          fix: 'Jobbiz crée le client quand l’entreprise a un SIRET valide et une adresse de facturation complète : corrigez-les sur sa fiche, ou créez le client dans Pennylane avec son SIRET, puis réessayez.',
        },
        ERR_ENTREPRISE_AMBIGUE_PENNYLANE: {
          label: 'Plusieurs clients Pennylane pour l’entreprise',
          explanation: 'Plusieurs clients Pennylane ont le SIRET ou le SIREN de l’entreprise.',
          fix: 'N’en gardez qu’un dans Pennylane, puis réessayez.',
        },
        ERR_FACTURE_AMBIGUE_PENNYLANE: {
          label: 'Facture en double ou archivée dans Pennylane',
          explanation: 'Pennylane tient le numéro de ces factures plusieurs fois, ou seulement en version archivée : Jobbiz ne peut pas savoir laquelle suivre.',
          fix: 'Dans Pennylane, n’en gardez qu’une, non archivée, puis réessayez.',
        },
        ERR_TVA_TAUX_INCONNU: {
          label: 'Taux de TVA inconnu',
          explanation: 'Le taux de {rates} appliqué sur ces factures n’est pas dans la table de Jobbiz.',
          explanationMany: 'Les taux de {rates} appliqués sur ces factures ne sont pas dans la table de Jobbiz.',
          explanationNoRate: 'Le taux de TVA de ces factures n’est pas dans la table de Jobbiz.',
          fix: 'Prévenez l’équipe technique pour qu’elle ajoute ce taux, puis réessayez.',
        },
        ERR_PENNYLANE_API: {
          label: 'Pennylane a refusé ou n’a pas répondu',
          explanation: 'Pennylane a refusé ces factures ou n’a pas répondu.',
          fix: 'Attendez quelques minutes, puis réessayez.',
        },
        ERR_PENNYLANE_CATEGORIE: {
          label: 'Catégorie non posée dans Pennylane',
          explanation: 'Ces factures sont dans Pennylane ; réessayer ne pose que la catégorie.',
          fix: 'Réessayez : seule la catégorie sera posée.',
        },
        ERR_PENNYLANE_ECHEANCE: {
          label: 'Échéance non posée dans Pennylane',
          explanation: 'Ces factures étaient déjà dans Pennylane ; l’échéance choisie pour elles n’y a pas été posée.',
          fix: 'Réessayez : seule l’échéance sera envoyée.',
        },
        ERR_PENNYLANE_ANNEXE: {
          label: 'Annexe non envoyée dans Pennylane',
          explanation: 'Ces factures sont importées, mais une de leurs annexes n’a pas pu être envoyée dans Pennylane.',
          fix: 'Si une annexe est « à vérifier dans Pennylane », cherchez-la d’abord dans Pennylane : supprimez-la dans Jobbiz, et ajoutez-la à nouveau si Pennylane ne l’a pas. Réessayez ensuite : seules les annexes en attente seront envoyées.',
        },
      },
      unknownError: {
        explanation: 'Cette erreur n’a pas encore de description dans Jobbiz.',
        fix: 'Transmettez le code à l’équipe technique, puis réessayez.',
      },
      history: {
        startedAt: '{date} à {time}',
        import: 'Import',
        listImportOne: 'Import de 1 facture',
        listImportMany: 'Import de {count} factures',
        retry: 'Réessai',
        by: 'par {name}',
        inProgress: 'en cours',
        seconds: '{s} s',
        minutes: '{m} min {s} s',
        hours: '{h} h {m} min',
        fetchedOne: '1 récupérée',
        fetchedMany: '{count} récupérées',
        importedOne: '1 importée',
        importedMany: '{count} importées',
        done: 'Terminé',
        inError: '{count} en erreur',
        running: 'En cours',
        failed: 'Échoué',
        interrupted: 'Interrompu',
        fatal: {
          ERR_BESTT_INDISPONIBLE: 'Bestt ne répondait pas : rien n’a été importé.',
          ERR_PASSAGE_INTERROMPU: 'Rien ne sera importé en double au prochain import.',
          generic: 'L’import a échoué.',
        },
        stepBestt: '1 · Récupération depuis Bestt',
        stepPennylane: '2 · Import dans Pennylane',
        stepFetchedOne: '1 facture récupérée',
        stepFetchedMany: '{count} factures récupérées',
        stepImportedOne: '1 facture importée',
        stepImportedMany: '{count} factures importées',
        toFixOne: '1 facture à corriger → voir l’onglet À corriger',
        toFixMany: '{count} factures à corriger → voir l’onglet À corriger',
        older: 'Voir les passages plus anciens',
        empty: 'Aucun import pour ce mois',
      },
    },
    invoiceDetail: {
      kicker: 'Facture client',
      title: 'N° {number} · {company}',
      titleLoading: 'N° {number}',
      besttClient: 'Client Bestt {id}',
      tabInformation: 'Informations',
      tabContacts: 'Contacts',
      tabHistory: 'Historique',
      tabComments: 'Commentaires',
      contactsNoCompany: 'Cette facture n’est rattachée à aucune entreprise.',
      loading: 'Chargement de la facture…',
      loadFailed: 'La facture n’a pas pu être chargée.',
      reloadFailed: 'La facture n’a pas pu être relue, rechargez-la.',
      notFound: 'Cette facture est introuvable.',
      reload: 'Recharger',
      banner: {
        notImportedTitle: 'Facture pas encore importée',
        notImportedText: 'Elle sera enregistrée dans Jobbiz et importée dans Pennylane au prochain import.',
        notImportedFetchedText: 'Elle est enregistrée dans Jobbiz et sera importée dans Pennylane au prochain import.',
        errorTitle: '{label} · {code}',
        lateTitleOne: 'Échéance dépassée de 1 jour',
        lateTitleMany: 'Échéance dépassée de {days} jours',
        lateText: 'Reste à payer : {remaining} · échéance au {date}.',
        lateTextNoRemaining: 'Échéance au {date}.',
      },
      information: {
        title: 'Informations',
        amount: 'Montant TTC',
        period: 'Période',
        company: 'Entreprise',
        category: 'Catégorie',
        paymentTerm: 'Délai de paiement',
        noCategory: 'Aucune catégorie',
        unknownCategory: 'Catégorie n° {id}',
        categoryModified: '{value} · modifiée',
        termModified: '{value} · modifié',
        termDefault: '{value} · par défaut',
        termDays: '{days} jours',
        atImport: '{value} · à l’import',
        withDueDate: '{value} · échéance le {date}',
        accountStatementNoCompany: 'Cette facture n’est rattachée à aucune entreprise.',
      },
      payment: {
        title: 'Paiement',
        remaining: 'Reste à payer',
        paid: 'Montant réglé',
        paidAt: 'Payée le',
      },
      companyTerms: {
        loadFailed: 'Les conditions de l’entreprise n’ont pas pu être chargées.',
        bonusesTitle: 'Primes & indemnités',
        bonusName: 'Nom',
        bonusUnit: 'Unité',
        bonusRate: 'Majoration',
        noBonuses: 'Aucune prime ni indemnité.',
      },
      preview: {
        loading: 'Chargement du PDF…',
        busy: 'Un import est en cours, réessayez dans un instant.',
        notFound: 'Le PDF de cette facture est introuvable.',
        besttFailed: 'Bestt n’a pas rendu le PDF, réessayez dans un instant.',
        failed: 'L’aperçu n’a pas pu être chargé.',
        retry: 'Réessayer',
        rotate: 'Pivoter',
        zoomOut: 'Zoom arrière',
        zoomIn: 'Zoom avant',
        previousPage: 'Page précédente',
        nextPage: 'Page suivante',
        pageOf: '{page} / {pages}',
        fitWidth: 'Ajuster à la largeur',
        expand: 'Agrandir',
        fullscreenTitle: 'Facture n° {number}',
        download: 'Télécharger le PDF',
        closeFullscreen: 'Fermer l’aperçu',
      },
      footer: {
        download: 'Télécharger le PDF',
        import: 'Importer dans Pennylane',
        retry: 'Réessayer l’import',
        running: 'Import en cours…',
        viewInPennylane: 'Voir dans Pennylane',
      },
      messages: {
        nothingToImport: 'Cette facture est déjà importée.',
        nothingToRetry: 'Cette facture n’est plus en erreur.',
        importFailed: 'L’import n’a pas pu être lancé, réessayez.',
        retryFailed: 'Le réessai n’a pas pu être lancé, réessayez.',
      },
    },
    invoiceInformation: {
      title: 'Informations de la facture',
      intro: 'S’applique à la facture n° {number} seulement, pas aux autres factures de l’entreprise.',
      category: 'Catégorie',
      noCategory: 'Aucune catégorie',
      unknownCategory: 'Catégorie n° {id}',
      categoryOfTheCompany: 'Catégorie de l’entreprise',
      categoryOfCompany: 'Catégorie de {company} : {name}',
      companyWithoutCategory: '{company} n’a pas de catégorie par défaut.',
      paymentTerm: 'Délai de paiement',
      paymentTermPlaceholder: 'Choisir un délai',
      termOfTheCompany: 'Délai de l’entreprise',
      termOfTheCompanyWithValue: 'Délai de l’entreprise : {term}',
      termOfCompany: 'Délai de {company} : {term}',
      termDefault: '{term} (par défaut)',
      restore: 'Rétablir',
      cancel: 'Annuler',
      save: 'Enregistrer',
      saving: 'Enregistrement…',
      saved: {
        updated: 'Enregistré dans Jobbiz et dans Pennylane.',
        on_import: 'Enregistré dans Jobbiz ; Pennylane le recevra à l’import.',
        skipped: 'Enregistré dans Jobbiz ; Pennylane n’est pas modifié hors production.',
        unchanged: 'Enregistré dans Jobbiz ; rien à changer dans Pennylane.',
      },
      errors: {
        partialTitle: 'Pennylane n’a pas pris toutes les modifications.',
        category: {
          saved: 'Catégorie : enregistrée.',
          failed: 'Catégorie : non enregistrée, Pennylane l’a refusée ou n’a pas répondu.',
        },
        paymentTerm: {
          saved: 'Délai de paiement : enregistré.',
          failed: 'Délai de paiement : non enregistré, Pennylane l’a refusé ou n’a pas répondu.',
        },
        PENNYLANE_INVOICE_NOT_FOUND: 'Cette facture est introuvable dans Pennylane : ce qui devait y être modifié n’est pas enregistré.',
        PENNYLANE_INVOICE_AMBIGUOUS: 'Cette facture est en double ou archivée dans Pennylane : ce qui devait y être modifié n’est pas enregistré. Dans Pennylane, n’en gardez qu’une, non archivée.',
        IMPORT_ALREADY_RUNNING: 'Un import de ce mois est en cours : réessayez quand il sera terminé.',
        INVOICE_INFORMATION_SAVING: 'Une autre facture de ce mois est en cours d’enregistrement : réessayez dans un instant.',
        INVOICE_WITHOUT_COMPANY: 'Cette facture n’a pas d’entreprise : sa catégorie et son délai ne se modifient pas.',
        generic: 'L’enregistrement a échoué, réessayez.',
      },
    },
    invoiceAppendices: {
      title: 'Annexes',
      add: 'Ajouter une annexe',
      dropHere: 'Glissez une annexe ici, ou utilisez le « + »',
      accepted: 'PDF, JPG ou PNG · 10 Mo max',
      uploading: 'Envoi de {name}…',
      loading: 'Chargement des annexes…',
      retry: 'Réessayer',
      by: 'par {name}',
      addedOn: 'ajoutée le {date}',
      download: 'Télécharger {name}',
      delete: 'Supprimer {name}',
      confirm: 'Elle est bien dans Pennylane',
      confirming: 'Confirmation…',
      confirmed: 'Annexe enregistrée comme envoyée dans Pennylane.',
      unconfirmedHelp: 'Pennylane n’a pas répondu à son envoi : elle y est peut-être. Cherchez-la d’abord dans Pennylane. Si elle y est, confirmez-le ici ; sinon, supprimez-la et ajoutez-la à nouveau.',
      pennylaneUnavailable: 'Annexes Pennylane indisponibles pour le moment.',
      source: {
        jobbiz: 'Jobbiz',
        pennylane: 'Pennylane',
      },
      status: {
        sent: 'Envoyée dans Pennylane',
        pending: 'En attente d’import',
        unconfirmed: 'À vérifier dans Pennylane',
      },
      added: {
        sent: 'Annexe ajoutée et envoyée dans Pennylane.',
        pending: 'Annexe ajoutée : elle sera envoyée dans Pennylane à l’import.',
        skipped: 'Ajoutée dans Jobbiz ; rien n’est envoyé à Pennylane hors production.',
        other: 'Annexe ajoutée.',
      },
      size: {
        locale: 'fr-FR',
        bytes: '{size} o',
        kilobytes: '{size} Ko',
        megabytes: '{size} Mo',
      },
      deleteModal: {
        title: 'Supprimer l’annexe',
        text: '« {name} » sera supprimée de Jobbiz.',
        remainsInPennylane: 'Elle restera dans Pennylane : la supprimer ici ne l’en retire pas. Elle ne sera plus jointe aux mails de Jobbiz.',
        cancel: 'Annuler',
        confirm: 'Supprimer',
        deleting: 'Suppression…',
        deleted: 'Annexe supprimée.',
        deletedRemains: 'Annexe supprimée de Jobbiz ; elle reste dans Pennylane.',
      },
      errors: {
        APPENDIX_FILE_MISSING: 'Aucun fichier reçu : déposez un seul fichier, non vide.',
        FILE_TOO_LARGE: 'Ce fichier dépasse 10 Mo.',
        APPENDIX_FILE_TYPE_INVALID: 'Ce fichier n’est ni un PDF, ni un JPG, ni un PNG.',
        APPENDIX_NOT_FOUND: 'Cette annexe n’existe plus : la liste est relue.',
        APPENDIX_FILE_NOT_FOUND: 'Le fichier de cette annexe est introuvable dans le stockage.',
        PENNYLANE_APPENDIX_FAILED: 'Pennylane a refusé cette annexe : rien n’est gardé.',
        PENNYLANE_APPENDIX_UNCONFIRMED: 'Pennylane n’a pas répondu : l’annexe a pu y être ajoutée. Vérifiez dans Pennylane avant de la déposer à nouveau, sinon elle y serait en double.',
        APPENDIX_NOT_UNCONFIRMED: 'Cette annexe n’est plus à vérifier : la liste est relue.',
        INVOICE_APPENDIX_CONFIRM_FAILED: 'La confirmation a échoué, réessayez.',
        INVOICE_WITHOUT_COMPANY: 'Cette facture n’a pas d’entreprise : elle ne prend pas d’annexe.',
        IMPORT_ALREADY_RUNNING: 'Un import de ce mois est en cours : réessayez quand il sera terminé.',
        INVOICE_INFORMATION_SAVING: 'Une autre facture de ce mois est en cours d’enregistrement : réessayez dans un instant.',
        PENNYLANE_INVOICE_NOT_FOUND: 'Cette facture est introuvable dans Pennylane : l’annexe n’est pas ajoutée.',
        PENNYLANE_INVOICE_AMBIGUOUS: 'Cette facture est en double ou archivée dans Pennylane : l’annexe n’est pas ajoutée. Dans Pennylane, n’en gardez qu’une, non archivée.',
        INVOICE_NOT_FOUND: 'Cette facture est introuvable.',
        loadFailed: 'Les annexes n’ont pas pu être chargées.',
        addFailed: 'L’ajout de l’annexe a échoué, réessayez.',
        downloadFailed: 'Le fichier n’a pas pu être téléchargé, réessayez.',
        pennylaneFile: {
          PENNYLANE_APPENDIX_FAILED: 'L’annexe n’a pas pu être récupérée dans Pennylane. Réessayez.',
        },
        deleteFailed: 'La suppression a échoué, réessayez.',
        confirmFailed: 'La confirmation a échoué, réessayez.',
        oneFileOnly: 'Déposez un seul fichier à la fois.',
      },
    },
    invoiceErrors: {
      ERR_BESTT_FACTURE_INTROUVABLE: {
        explanation: 'Bestt dit ne pas connaître cette facture.',
        fix: 'Vérifiez cette facture dans Bestt, puis réessayez.',
      },
      ERR_BESTT_API: {
        explanation: 'Bestt a échoué sur cette facture.',
        fix: 'Attendez quelques minutes, puis réessayez.',
      },
      ERR_ENTREPRISE_INCONNUE_JOBBIZ: {
        explanation: 'Aucune entreprise Jobbiz n’a le client Bestt de cette facture.',
        fix: 'Renseignez l’identifiant Bestt dans la fiche de l’entreprise, puis réessayez.',
      },
      ERR_ENTREPRISE_AMBIGUE_JOBBIZ: {
        explanation: 'Plusieurs entreprises Jobbiz ont le client Bestt de cette facture.',
        fix: 'Ne laissez cet identifiant Bestt qu’à une seule entreprise, puis réessayez.',
      },
      ERR_BESTT_PDF_INDISPONIBLE: {
        explanation: 'Bestt n’a pas rendu le PDF de cette facture.',
        fix: 'Attendez quelques minutes, puis réessayez.',
      },
      ERR_STOCKAGE_PDF: {
        explanation: 'Le PDF de cette facture n’a pas pu être rangé ou relu.',
        fix: 'Attendez quelques minutes, puis réessayez.',
      },
      ERR_PENNYLANE_DESACTIVE: {
        explanation: 'Hors production, rien n’est envoyé à Pennylane.',
        fix: 'Rien à corriger : normal hors production.',
      },
      ERR_ENTREPRISE_INTROUVABLE_PENNYLANE: {
        explanation: 'Aucun client Pennylane ne correspond à l’entreprise, et Jobbiz n’a pas pu le créer.',
        fix: 'Jobbiz crée le client quand l’entreprise a un SIRET valide et une adresse de facturation complète : corrigez-les sur sa fiche, ou créez le client dans Pennylane avec son SIRET, puis réessayez.',
      },
      ERR_ENTREPRISE_AMBIGUE_PENNYLANE: {
        explanation: 'Plusieurs clients Pennylane ont le SIRET ou le SIREN de l’entreprise.',
        fix: 'N’en gardez qu’un dans Pennylane, puis réessayez.',
      },
      ERR_FACTURE_AMBIGUE_PENNYLANE: {
        explanation: 'Pennylane tient le numéro de cette facture plusieurs fois, ou seulement en version archivée : Jobbiz ne peut pas savoir laquelle suivre.',
        fix: 'Dans Pennylane, n’en gardez qu’une, non archivée, puis réessayez.',
      },
      ERR_TVA_TAUX_INCONNU: {
        explanation: 'Le taux de {rate} appliqué à cette facture n’est pas dans la table de Jobbiz.',
        explanationNoRate: 'Le taux de TVA de cette facture n’est pas dans la table de Jobbiz.',
        fix: 'Prévenez l’équipe technique pour qu’elle ajoute ce taux, puis réessayez.',
      },
      ERR_PENNYLANE_API: {
        explanation: 'Pennylane a refusé cette facture ou n’a pas répondu.',
        fix: 'Attendez quelques minutes, puis réessayez.',
      },
      ERR_PENNYLANE_CATEGORIE: {
        explanation: 'Cette facture est dans Pennylane ; réessayer ne pose que la catégorie.',
        fix: 'Réessayez : seule la catégorie sera posée.',
      },
      ERR_PENNYLANE_ECHEANCE: {
        explanation: 'Cette facture était déjà dans Pennylane ; l’échéance choisie pour elle n’y a pas été posée.',
        fix: 'Réessayez : seule l’échéance sera envoyée.',
      },
      ERR_PENNYLANE_ANNEXE: {
        explanation: 'Cette facture est importée, mais une de ses annexes n’a pas pu être envoyée dans Pennylane.',
        fix: 'Si une annexe est « à vérifier dans Pennylane », cherchez-la d’abord dans Pennylane : supprimez-la dans Jobbiz, et ajoutez-la à nouveau si Pennylane ne l’a pas. Réessayez ensuite : seules les annexes en attente seront envoyées.',
      },
    },
    invoiceHistory: {
      loading: 'Chargement de l’historique…',
      empty: 'Aucun évènement',
      notFound: 'Cette facture est introuvable : elle n’a pas d’historique.',
      loadFailed: 'L’historique n’a pas pu être chargé.',
      retryLoad: 'Réessayer',
      at: '{date} à {time}',
      by: 'par {name}',
      retryBy: 'réessai · par {name}',
      retry: 'réessai',
      automatic: 'automatique',
      migrated: 'Reprise de l’ancien import : historique antérieur indisponible',
      unknownDate: 'Date inconnue',
      transition: '{from} → {to}',
      types: {
        fetched: 'Récupérée depuis Bestt',
        imported: 'Importée dans Pennylane',
        import_failed: 'Erreur d’import',
        pennylane_category_set: 'Catégorie posée dans Pennylane',
        category_changed: 'Catégorie modifiée',
        payment_term_changed: 'Délai de paiement modifié',
        payment_status_changed: 'Statut de paiement modifié',
        appendix_added: 'Annexe ajoutée',
        appendix_sent: 'Annexe envoyée dans Pennylane',
        appendix_deleted: 'Annexe supprimée',
        sent_by_mail: 'Facture envoyée par mail',
        reminder_sent: 'Relance envoyée',
        litigation_opened: 'Passage en contentieux',
        litigation_closed: 'Sortie du contentieux',
        reminders_suspended: 'Relances automatiques suspendues',
        reminders_resumed: 'Relances automatiques reprises',
        comment_deleted: 'Commentaire supprimé',
        unknown: 'Autre évènement',
      },
      details: {
        linked: 'Rattachée : Pennylane avait déjà cette facture',
        sent: 'Envoyée dans Pennylane par Jobbiz',
        customerCreated: 'Client créé dans Pennylane par Jobbiz',
        noCategory: 'Aucune catégorie',
        unknownCategory: 'Catégorie n° {id}',
        termDays: '{days} jours',
        newDueDate: 'Nouvelle échéance le {date}',
        sameDueDate: 'Échéance inchangée',
        categoryPennylane: {
          updated: 'Mise à jour dans Pennylane',
          on_import: 'Sera posée dans Pennylane à l’import',
          skipped: 'Pennylane non modifié hors production',
        },
        termPennylane: {
          updated: 'Échéance mise à jour dans Pennylane',
          on_import: 'Échéance envoyée à Pennylane à l’import',
          skipped: 'Pennylane non modifié hors production',
        },
        appendix: {
          sent: 'Envoyée dans Pennylane',
          pending: 'En attente d’import',
          skipped: 'Non envoyée dans Pennylane hors production',
        },
        remainsInPennylane: 'Elle reste dans Pennylane',
        confirmedByAdmin: 'Confirmée par un admin',
        reminderLevel: {
          before_due: 'Rappel',
          first: 'Relance 1/3',
          second: 'Relance 2/3',
          third: 'Relance 3/3',
        },
        reminderTrigger: {
          manual: 'manuelle',
          auto: 'automatique',
        },
        recipientsOne: '{count} destinataire',
        recipientsMany: '{count} destinataires',
        redirected: 'Envoyée à l’adresse de test : aucun client ne l’a reçue',
      },
    },
    invoiceComments: {
      tabWithCount: 'Commentaires ({count})',
      loading: 'Chargement des commentaires…',
      empty: 'Aucun commentaire',
      notFound: 'Cette facture est introuvable : elle n’a pas de commentaires.',
      loadFailed: 'Les commentaires n’ont pas pu être chargés.',
      retryLoad: 'Réessayer',
      deletedAuthor: 'Compte supprimé',
      unnamedAuthor: 'Auteur sans nom',
      at: '{date} à {time}',
      inputLabel: 'Votre commentaire',
      placeholder: 'Écrire un commentaire…',
      submit: 'Commenter',
      counter: '{count} / {max}',
      tooLong: 'Un commentaire fait au plus 2 000 caractères.',
      errors: {
        invalid: 'Le commentaire doit faire de 1 à 2 000 caractères.',
        notFound: 'Cette facture est introuvable : le commentaire n’a pas été enregistré.',
        failed: 'Le commentaire n’a pas pu être enregistré. Réessayez.',
      },
      deleteLabel: 'Supprimer le commentaire',
      deleteErrors: {
        forbidden: 'Seul l’auteur du commentaire ou un super-admin peut le supprimer.',
        failed: 'Le commentaire n’a pas pu être supprimé. Réessayez.',
      },
      edited: 'modifié',
      editLabel: 'Modifier le commentaire',
      editInputLabel: 'Modifier le commentaire',
      editCancel: 'Annuler',
      editSubmit: 'Enregistrer',
      editErrors: {
        invalid: 'Le commentaire doit faire de 1 à 2 000 caractères.',
        forbidden: 'Seul l’auteur du commentaire peut le modifier.',
        failed: 'Le commentaire n’a pas pu être modifié. Réessayez.',
      },
    },
    invoiceSendMail: {
      title: 'Envoyer par mail',
      open: 'Envoyer par mail',
      close: 'Fermer',
      intro: 'Les factures sont envoyées en PDF aux contacts de facturation de chaque entreprise.',
      scopesLabel: 'Factures à envoyer',
      scope: {
        selectionOne: 'Cette facture',
        selectionOneDetail: 'N°{number} · {company} · {amount}',
        selectionMany: 'Ces factures',
        selectionManyDetail: '{count} factures sélectionnées',
        company: 'Toutes les factures de {company}',
        group: 'Toutes les factures du groupe {group}',
        invoicesOne: '{count} facture',
        invoicesMany: '{count} factures',
        companiesOne: '{count} entreprise',
        companiesMany: '{count} entreprises',
      },
      recipients: {
        title: 'Destinataires · contacts de facturation de {company}',
        none: 'Aucun contact de facturation pour cette entreprise.',
        member: 'Membre',
        pendingMember: 'Invitation en attente',
        external: 'Externe',
        unnamed: 'Contact sans nom',
      },
      withoutCompany: 'Sans entreprise',
      notSendable: {
        title: 'Écartées, non envoyables :',
        item: 'N°{number} · {status}',
      },
      status: {
        error: 'Erreur',
        draft: 'Brouillon',
        pending: 'En attente',
        partiallyPaid: 'Partiellement payé',
        paid: 'Payé',
        cancelled: 'Annulée',
        notImported: 'Non importé',
      },
      loading: 'Chargement des factures et des contacts…',
      reload: 'Réessayer',
      cancel: 'Annuler',
      sendOne: 'Envoyer {count} facture',
      sendMany: 'Envoyer {count} factures',
      sending: 'Envoi en cours…',
      retrySend: 'Réessayer l’envoi',
      frozenNotice: 'Le premier envoi a peut-être abouti : la sélection est figée. Réessayez l’envoi à l’identique ou fermez la fenêtre.',
      entry: {
        notSendable: 'Seules les factures en attente, partiellement payées ou payées s’envoient par mail.',
        tooMany: 'Envoyer {max} factures au plus à la fois',
      },
      report: {
        sentOne: '{count} facture envoyée',
        sentMany: '{count} factures envoyées',
        failedOne: '{count} facture en échec',
        failedMany: '{count} factures en échec',
        skippedOne: '{count} facture sautée',
        skippedMany: '{count} factures sautées',
        nothingSent: 'Aucune facture envoyée',
        replayed: 'Cet envoi avait déjà été fait : rien n’a été renvoyé.',
        line: '{company} : {reason}',
        noRecipient: 'aucun destinataire coché',
        unknownCompany: 'Une entreprise',
      },
      companyErrors: {
        INVOICE_PDF_MISSING: 'le PDF d’une facture manque',
        APPENDIX_FILE_NOT_FOUND: 'une annexe est introuvable',
        ATTACHMENTS_TOO_LARGE: 'les pièces jointes dépassent 20 Mo',
        BILLING_MAIL_SEND_FAILED: 'le service de mails a refusé l’envoi',
        INVOICE_MAIL_FAILED: 'l’envoi a échoué',
        INVOICE_NOT_SENDABLE: {
          one: '{numbers} écartée, non envoyable',
          many: '{numbers} écartées, non envoyables',
        },
      },
      errors: {
        INVOICE_NUMBERS_INVALID: 'Cette sélection ne peut pas être envoyée : de 1 à 200 factures à la fois.',
        SCOPE_INVALID: 'Ce choix de factures n’est pas reconnu.',
        SCOPE_UNAVAILABLE: 'Ce choix n’est plus possible pour cette sélection : choisissez-en un autre.',
        PERIOD_MIXED: 'Les factures sélectionnées doivent être du même mois.',
        SCOPE_TOO_LARGE: 'Trop de factures pour un seul envoi : 300 factures et 30 entreprises au plus.',
        RECIPIENTS_INVALID: 'Un destinataire coché n’est plus un contact de facturation de son entreprise : fermez et rouvrez la fenêtre.',
        NOTHING_TO_SEND: 'Aucune facture envoyable n’a de destinataire coché.',
        REQUEST_ID_INVALID: 'Cet envoi n’a pas pu être identifié : fermez et rouvrez la fenêtre.',
        INVOICE_NOT_FOUND: 'Une facture de la sélection est introuvable.',
        SEND_IN_PROGRESS: 'Cet envoi est encore en cours : patientez, puis réessayez. Rien ne partira deux fois.',
        BILLING_MAIL_DISABLED: 'L’envoi de mails est coupé sur cet environnement.',
        BILLING_MAIL_TEMPLATE_MISSING: 'Le modèle du mail de facture manque sur cet environnement.',
        prepareFailed: 'Les factures et les contacts n’ont pas pu être chargés.',
        generic: 'L’envoi a échoué, réessayez.',
        network: 'Le serveur n’a pas répondu. Réessayez : un envoi déjà parti ne partira pas deux fois.',
      },
    },
    invoiceReminders: {
      tabCount: '{count} à faire',
      remindAll: 'Tout relancer',
      remindAllRunning: 'Relance en cours…',
      cards: {
        toDo: 'À faire',
        late: 'En retard',
        litigation: 'Contentieux',
        invoicesOne: '{count} facture',
        invoicesMany: '{count} factures',
        litigationValue: '{count} · {amount}',
        unknown: '—',
      },
      tabs: {
        label: 'Relances',
        todo: 'À faire',
        upcoming: 'À venir',
        litigation: 'Contentieux',
        settled: 'Réglées',
      },
      columns: {
        number: 'N°',
        company: 'Entreprise',
        remaining: 'Reste à payer',
        late: 'Retard',
        step: 'À envoyer',
        passage: 'Passage',
        status: 'Statut',
      },
      row: {
        invoiceOf: 'Facture {month}',
        noCompany: 'Sans entreprise',
        lateDaysOne: '{days} jour',
        lateDaysMany: '{days} jours',
        lateSince: 'depuis le {date}',
        notLate: 'Pas en retard',
        dueOn: 'échéance le {date}',
        nextOn: 'le {date}',
        remind: 'Relancer',
        open: 'Ouvrir',
        moreActions: 'Plus d’actions sur la facture {number}',
        suspend: 'Suspendre les relances',
        resume: 'Reprendre les relances',
      },
      badges: {
        before_due: 'Rappel',
        first: 'Relance 1/3',
        second: 'Relance 2/3',
        third: 'Relance 3/3',
        exhausted: 'Relances épuisées',
        noRecipient: 'Sans destinataire',
        suspended: 'Suspendue',
        uncertain: 'Envoi incertain',
        litigation: 'Contentieux',
      },
      badgeHints: {
        noRecipient: 'Aucun contact « Relances » dans l’entreprise : personne ne recevrait la relance.',
        suspended: 'Les relances automatiques de cette facture sont arrêtées.',
        uncertain: 'Un envoi est resté en cours plus de 10 minutes : vérifiez l’historique avant de relancer.',
      },
      suspension: {
        suspended: 'Relances automatiques suspendues pour la facture N°{number}.',
        resumedNext: 'Relances automatiques reprises pour la facture N°{number} : prochaine relance le {date}.',
        resumedNone: 'Relances automatiques reprises pour la facture N°{number} : aucune relance automatique n’est prévue.',
        errors: {
          INVOICE_NOT_REMINDABLE: 'Cette facture n’est plus relancée (réglée, annulée ou en contentieux) : la liste est relue.',
          INVOICE_NOT_FOUND: 'Cette facture est introuvable.',
          generic: 'Le changement n’a pas pu être enregistré, réessayez.',
        },
      },
      list: {
        loading: 'Chargement des relances…',
        loadFailed: 'La liste des relances n’a pas pu être chargée.',
        retry: 'Réessayer',
        showingRange: 'Affichage de {start}-{end} sur {total} résultats',
        showingAll: 'Affichage de {total} résultats',
        totalLate: 'Total en retard : {amount}',
        totalOwed: 'Total restant dû : {amount}',
        totalLitigation: 'Total en contentieux : {amount}',
        filteredEmptyTitle: 'Aucune facture ne correspond à cette recherche.',
        clearSearch: 'Effacer la recherche',
        empty: {
          todo: {
            title: 'Aucune facture à relancer',
            text: 'Les factures dont une relance est due apparaîtront ici.',
          },
          upcoming: {
            title: 'Aucune relance à venir',
            text: 'Les factures non réglées dont la prochaine relance n’est pas encore due apparaîtront ici.',
          },
          litigation: {
            title: 'Aucune facture en contentieux',
            text: 'Les factures confiées au contentieux apparaîtront ici.',
          },
          settled: {
            title: 'Aucune facture réglée après relance',
            text: 'Les factures payées après au moins une relance apparaîtront ici.',
          },
        },
      },
      remindAllModal: {
        title: 'Tout relancer',
        loading: 'Calcul des factures à relancer…',
        loadFailed: 'Les factures à relancer n’ont pas pu être comptées.',
        retryLoad: 'Réessayer',
        intro: 'Chaque facture d’« À faire » reçoit maintenant sa relance due, PDF joint, envoyée à ses contacts « Relances ».',
        countOne: '{count} facture sera relancée :',
        countMany: '{count} factures seront relancées :',
        nothing: 'Aucune facture d’« À faire » n’a de relance à envoyer.',
        step: '{label} : {count}',
        suspendedRule: 'Les factures suspendues ne sont pas relancées.',
        suspendedOne: '{count} facture suspendue ne sera pas relancée.',
        suspendedMany: '{count} factures suspendues ne seront pas relancées.',
        exhaustedOne: '{count} facture aux relances épuisées n’a plus de relance à envoyer.',
        exhaustedMany: '{count} factures aux relances épuisées n’ont plus de relance à envoyer.',
        triedRule: 'Une relance déjà tentée (en échec ou « Envoi incertain ») n’est pas renvoyée : relancez ces factures une par une.',
        cancel: 'Annuler',
        confirm: 'Tout relancer',
        starting: 'Lancement…',
        errors: {
          REMINDER_RUN_ALREADY_RUNNING: 'Un passage de relances est déjà en cours.',
          BILLING_MAIL_DISABLED: 'L’envoi de mails est coupé sur cet environnement.',
          BILLING_MAIL_TEMPLATE_MISSING: 'Le modèle du mail de relance manque sur cet environnement.',
          INVOICE_NUMBERS_INVALID: 'La liste des factures à relancer n’est pas valide.',
          generic: 'Le passage n’a pas pu être lancé, réessayez.',
        },
      },
      run: {
        alreadyRunning: 'Un passage de relances est déjà en cours : son compte rendu s’affichera à la fin.',
        done: 'Tout relancer : passage terminé',
        failed: 'Tout relancer : le passage s’est arrêté en échec',
        skipped: 'Tout relancer : le passage n’a pas eu lieu',
        counters: 'Envoyées : {sent} · échouées : {failed} · sans destinataire : {noRecipient} · déjà réglées : {settled} · déjà réservées : {alreadyClaimed}',
        lost: 'Le suivi du passage a été perdu : relisez la liste dans un moment.',
      },
      reminderModal: {
        title: 'Envoyer une relance',
        close: 'Fermer',
        summary: {
          number: 'N°{number}',
          remaining: 'reste à payer {amount}',
          lateOne: '{days} jour de retard',
          lateMany: '{days} jours de retard',
          dueOn: 'échéance le {date}',
        },
        loading: 'Préparation de la relance…',
        reload: 'Réessayer',
        recipientsLabel: 'Destinataires',
        recipients: {
          none: 'Aucun contact de facturation pour cette entreprise.',
          member: 'Membre',
          pendingMember: 'Invitation en attente',
          external: 'Externe',
          unnamed: 'Contact sans nom',
        },
        levelLabel: 'Modèle de relance',
        levels: {
          before_due: 'Rappel · Échéance proche',
          first: 'Relance 1/3 · Facture impayée',
          second: 'Relance 2/3 · Second rappel',
          third: 'Relance 3/3 · Mise en demeure amiable',
        },
        levelLoading: 'Chargement du modèle…',
        levelFailed: 'Ce modèle n’a pas pu être chargé : le précédent est gardé, réessayez.',
        messageLabel: 'Message',
        messageTooLong: 'Le message dépasse {max} caractères ({count} saisis).',
        attachment: 'La facture PDF est jointe automatiquement.',
        suspend: 'Suspendre les relances automatiques pour cette facture',
        nextAutomatic: 'Prochaine relance automatique prévue le {date}.',
        alreadySuspended: 'Les relances automatiques de cette facture sont déjà suspendues.',
        cancel: 'Annuler',
        send: 'Envoyer la relance',
        sending: 'Envoi en cours…',
        retrySend: 'Réessayer l’envoi',
        frozenNotice: 'La première tentative a peut-être abouti : la relance est figée. Réessayez l’envoi à l’identique ou fermez la fenêtre.',
        sent: 'Relance envoyée pour la facture N°{number}.',
        sentSuspended: 'Relance envoyée pour la facture N°{number} ; ses relances automatiques sont suspendues.',
        replayed: 'Cette relance de la facture N°{number} avait déjà été envoyée : rien n’a été renvoyé.',
        draftErrors: {
          INVOICE_NOT_REMINDABLE: 'Cette facture n’est pas relancée : réglée, annulée, avoir, sans échéance ou non importée.',
          INVOICE_IN_LITIGATION: 'Cette facture est en contentieux : sortez-la d’abord du contentieux pour la relancer.',
          INVOICE_NOT_FOUND: 'Cette facture est introuvable.',
          generic: 'La relance n’a pas pu être préparée.',
        },
        errors: {
          INVOICE_SETTLED: 'La facture a été réglée entre-temps : aucune relance n’est partie.',
          INVOICE_IN_LITIGATION: 'Cette facture est en contentieux : sortez-la d’abord du contentieux pour la relancer.',
          INVOICE_NOT_REMINDABLE: 'Cette facture n’est plus relancée (réglée, annulée ou sans échéance) : aucune relance n’est partie.',
          SEND_IN_PROGRESS: 'Cette relance est encore en cours d’envoi : patientez, puis réessayez. Rien ne partira deux fois.',
          LEVEL_INVALID: 'Ce modèle de relance n’est pas reconnu.',
          MESSAGE_INVALID: 'Le message doit compter de 1 à 5 000 caractères.',
          RECIPIENTS_INVALID: 'Un destinataire coché n’est plus un contact de facturation de l’entreprise : fermez et rouvrez la fenêtre.',
          REQUEST_ID_INVALID: 'Cet envoi n’a pas pu être identifié : fermez et rouvrez la fenêtre.',
          INVOICE_NOT_FOUND: 'Cette facture est introuvable.',
          MAIL_SEND_FAILED: 'Le mail de relance n’a pas pu partir : aucune relance n’a été envoyée. Vous pouvez réessayer, ce sera un nouvel envoi.',
          PENNYLANE_READ_FAILED: 'Le statut de la facture n’a pas pu être relu dans Pennylane : rien n’est parti. Réessayez dans un moment.',
          BILLING_MAIL_DISABLED: 'L’envoi de mails est coupé sur cet environnement.',
          BILLING_MAIL_TEMPLATE_MISSING: 'Le modèle du mail de relance manque sur cet environnement.',
          generic: 'L’envoi a échoué, réessayez.',
          network: 'Le serveur n’a pas répondu. Réessayez : une relance déjà partie ne partira pas deux fois.',
        },
      },
      detail: {
        remind: 'Envoyer une relance',
      },
      litigation: {
        bannerTitleOne: '{count} facture en contentieux',
        bannerTitleMany: '{count} factures en contentieux',
        bannerText: 'Les relances automatiques sont arrêtées. À transmettre pour recouvrement.',
        lastSent: '{label} le {date}',
        noneSent: 'Aucune relance envoyée',
        since: 'Depuis le {date}',
        start: 'Passer en contentieux',
        end: 'Sortir du contentieux',
        startModal: {
          title: 'Passer en contentieux',
          text: 'Passer la facture N°{number} en contentieux ? Les relances automatiques et manuelles s’arrêtent jusqu’à sa sortie.',
          cancel: 'Annuler',
          confirm: 'Passer en contentieux',
          pending: 'Passage en cours…',
          done: 'La facture N°{number} est passée en contentieux.',
        },
        endModal: {
          title: 'Sortir du contentieux',
          text: 'Sortir la facture N°{number} du contentieux ? Elle revient dans les relances, sans rattrapage : les relances déjà échues repassent dans « À faire » et attendent un admin.',
          cancel: 'Annuler',
          confirm: 'Sortir du contentieux',
          pending: 'Sortie en cours…',
          doneNext: 'La facture N°{number} est sortie du contentieux. Prochaine relance automatique prévue le {date}.',
          doneNone: 'La facture N°{number} est sortie du contentieux. Aucune relance automatique prévue.',
        },
        errors: {
          INVOICE_NUMBER_INVALID: 'Ce numéro de facture n’est pas valide.',
          INVOICE_NOT_FOUND: 'Cette facture est introuvable.',
          ALREADY_IN_LITIGATION: 'Cette facture est déjà en contentieux.',
          INVOICE_SETTLED: 'Cette facture est réglée ou annulée : elle ne peut pas passer en contentieux.',
          INVOICE_NOT_LATE: 'Cette facture n’est pas en retard : elle ne peut pas passer en contentieux.',
          NOT_IN_LITIGATION: 'Cette facture n’est plus en contentieux.',
          INVOICE_LITIGATION_FAILED: 'Le serveur n’a pas pu enregistrer le changement : rien n’a changé, réessayez.',
          forbidden: 'Vous n’avez pas accès aux factures.',
          generic: 'Le changement n’a pas pu être enregistré, réessayez.',
          network: 'Pas de réponse du serveur : le changement a peut-être été enregistré. La liste est relue.',
        },
      },
    },
    invoiceList: {
      tabInvoices: 'Factures',
      tabReminders: 'Relances',
      importButton: 'Importer',
      columnNumber: 'N°',
      columnCompany: 'Entreprise',
      columnAmount: 'Montant TTC',
      columnRemaining: 'Reste à payer',
      columnStatus: 'Statut',
      besttClient: 'Client Bestt {id}',
      viewInvoice: 'Voir la facture',
      status: {
        error: 'Erreur',
        draft: 'Brouillon',
        pending: 'En attente',
        partiallyPaid: 'Partiellement payé',
        paid: 'Payé',
        cancelled: 'Annulée',
        notImported: 'Non importé',
      },
      late: 'En retard · {days} j',
      statusTooltip: {
        notImported: 'Pas encore récupérée depuis Bestt ni envoyée dans Pennylane.',
        draft: 'Importée dans Pennylane en brouillon, pas encore finalisée.',
        pending: 'Finalisée dans Pennylane, en attente de paiement.',
        partiallyPaid: '{paid} réglés · reste {remaining} à payer.',
        partiallyPaidPaidOnly: '{paid} réglés.',
        partiallyPaidRemainingOnly: 'Reste {remaining} à payer.',
        partiallyPaidUnknown: 'Réglée en partie.',
        paidOn: 'Réglée en totalité le {date}.',
        paid: 'Réglée en totalité.',
        late: 'Échéance du {date} dépassée.',
        lateNoDate: 'Échéance dépassée.',
        cancelled: 'Annulée dans Pennylane, exclue des montants à encaisser.',
        error: 'Import échoué : {cause}.',
        errorUnknown: 'Import échoué.',
        errorCauses: {
          ERR_BESTT_FACTURE_INTROUVABLE: 'Bestt ne connaît pas cette facture',
          ERR_BESTT_API: 'Bestt a échoué sur cette facture',
          ERR_ENTREPRISE_INCONNUE_JOBBIZ: 'aucune entreprise Jobbiz n’a ce client Bestt',
          ERR_ENTREPRISE_AMBIGUE_JOBBIZ: 'plusieurs entreprises Jobbiz ont ce client Bestt',
          ERR_BESTT_PDF_INDISPONIBLE: 'Bestt n’a pas rendu le PDF',
          ERR_STOCKAGE_PDF: 'le PDF n’a pas pu être rangé ou relu',
          ERR_PENNYLANE_DESACTIVE: 'hors production, rien n’est envoyé à Pennylane',
          ERR_ENTREPRISE_INTROUVABLE_PENNYLANE: 'aucun client Pennylane pour cette entreprise',
          ERR_ENTREPRISE_AMBIGUE_PENNYLANE: 'plusieurs clients Pennylane pour ce SIRET ou ce SIREN',
          ERR_FACTURE_AMBIGUE_PENNYLANE: 'plusieurs versions de cette facture dans Pennylane, ou seulement des archivées',
          ERR_TVA_TAUX_INCONNU: 'taux de TVA inconnu',
          ERR_PENNYLANE_API: 'Pennylane a refusé la facture ou n’a pas répondu',
        },
        errorSentences: {
          ERR_PENNYLANE_CATEGORIE: 'Facture importée, mais sa catégorie n’est pas posée.',
          ERR_PENNYLANE_ECHEANCE: 'Facture importée, mais son échéance n’est pas posée dans Pennylane.',
          ERR_PENNYLANE_ANNEXE: 'Facture importée, mais une annexe n’est pas envoyée dans Pennylane.',
        },
      },
      loadFailed: 'La liste des factures n’a pas pu être chargée.',
      retry: 'Réessayer',
      loading: 'Chargement des factures…',
      emptyTitle: 'Aucune facture pour {month}',
      emptyText: 'Les factures du mois apparaîtront ici dès qu’elles seront générées. Changez de mois ou modifiez vos filtres pour en voir d’autres.',
      seeMonth: 'Voir {month}',
      showingRange: 'Affichage de {start}-{end} sur {total} résultats',
      showingAll: 'Affichage de {total} résultats',
      total: 'Total : {amount}',
      searchScopeLabel: 'Recherche dans',
      searchScope: {
        all: 'Tous',
        company: 'Entreprise',
        group: 'Groupe',
        number: 'N° de facture',
      },
      searchPlaceholder: 'Rechercher',
      filteredEmptyTitle: 'Aucune facture ne correspond à ces filtres.',
      clearFilters: 'Effacer les filtres',
      statusFilterLabel: 'Statut',
      statusFilter: {
        all: 'Tous les statuts',
        late: 'En retard',
      },
      selection: {
        selectPage: 'Sélectionner les factures de la page',
        selectInvoice: 'Sélectionner la facture {number}',
        barLabel: 'Actions sur la sélection',
        countOne: '1 facture sélectionnée',
        countMany: '{count} factures sélectionnées',
        retry: 'Réessayer',
        nothingToRetry: 'Plus aucune facture de la sélection n’est en erreur.',
        sendByMail: 'Envoyer par mail',
        exportCsv: 'Export CSV',
        exportTooMany: 'Exporter {max} factures au plus à la fois',
        exportFailed: 'L’export CSV n’a pas pu être fait, réessayez.',
        exportPeriodInvalid: 'Ce mois ne peut pas être exporté.',
        exportSelectionInvalid: 'Cette sélection ne peut pas être exportée.',
      },
      displayMode: {
        label: 'Affichage',
        all: 'Toutes les factures',
        byCompany: 'Par entreprise',
        byGroup: 'Par groupe',
      },
      grouping: {
        invoicesOne: '1 facture',
        invoicesMany: '{count} factures',
        companiesOne: '1 entreprise',
        companiesMany: '{count} entreprises',
        groupRowsOne: '1 groupe ou entreprise',
        groupRowsMany: '{count} groupes ou entreprises',
        groupLabel: 'Groupe',
        noGroup: 'Sans groupe',
        noCompany: 'Sans entreprise',
        unnamed: 'Sans nom',
        remainingPartial: 'Reste connu pour une partie des factures seulement',
        selectGroup: 'Sélectionner les factures de {name}',
        selectFailed: 'Les factures de {name} n’ont pas pu être sélectionnées, réessayez.',
        unfold: 'Déplier {name}',
        fold: 'Replier {name}',
        status: {
          errorOne: '1 en erreur',
          errorMany: '{count} en erreur',
          lateOne: '1 en retard',
          lateMany: '{count} en retard',
          notImportedOne: '1 non importée',
          notImportedMany: '{count} non importées',
          draftOne: '1 brouillon',
          draftMany: '{count} brouillons',
          pendingOne: '1 en attente',
          pendingMany: '{count} en attente',
          partiallyPaidOne: '1 partiellement payée',
          partiallyPaidMany: '{count} partiellement payées',
          paidOne: '1 payée',
          paidMany: '{count} payées',
          cancelledOne: '1 annulée',
          cancelledMany: '{count} annulées',
        },
      },
    },
    unreadApplications: {
      badgeOne: '1 nouvelle candidature depuis votre dernière visite',
      badgeOther: '{count} nouvelles candidatures depuis votre dernière visite',
    },
    inviteCandidates: {
      lastMission: 'Dernière mission :',
      alreadyInvited: 'Déjà invité',
    },
    missionCreation: {
      motifForm: {
        titles: {
          customaryContract: 'Contrat temporaire d’usage',
          replacement: 'Remplacement d’un salarié absent',
          activityIncrease: "Accroissement temporaire d'activité",
          awaitingRecruitment: 'En attente de recrutement',
          seasonal: 'Emploi à caractère saisonnier',
        },
        description: 'Votre description',
        maxLengthHint: '250 caractères',
        lengthError: 'Veuillez faire un message de plus de 10 caractères',
        name: 'Nom',
        firstname: 'Prénom',
        replacedPosition: 'Poste remplacé',
        absenceDescription:
          'Décrivez précisément le motif de l’absence de votre salarié.',
        date: 'Date',
        nameRequired: 'Veuillez indiquer un nom',
        firstnameRequired: 'Veuillez indiquer un prénom',
        positionRequired: 'Veuillez indiquer un poste',
        nameMissing: 'Un nom est requis',
        firstnameMissing: 'Un prénom est requis',
        dateMissing: 'Une date est requise',
        cancel: 'Annuler',
        confirm: 'Confirmer',
      },
    },
    missionTemplate: {
      createTitle: "Création d'une fiche de poste",
      editTitle: "Modification d'une fiche de poste",
      saveButton: 'Enregistrer la fiche',
      steps: {
        activity: "Secteur d'activité",
        risk: 'Poste à risque',
        prerequis: 'Prérequis',
        tasks: 'Tâches',
        locationSalary: 'Lieu & rémunération',
        confirmation: 'Confirmation',
      },
      dressCode: {
        label: 'Dress code',
        placeholder: 'Ex : pantalon noir, haut blanc uni, chaussures de sécurité',
        tooLong: 'Le dress code ne doit pas dépasser 500 caractères',
      },
      tools: {
        label: 'Matériel nécessaire',
      },
      tasks: {
        title: 'Tâches du poste',
        description: 'Cochez les tâches proposées ou ajoutez les vôtres.',
        addPlaceholder: 'Ajouter une tâche (ex : accueil des livreurs)',
        addButton: 'Ajouter',
        selectedCountOne: '{count} tâche',
        selectedCountOther: '{count} tâches',
        selectedOfOne: 'sélectionnée sur {total}',
        selectedOfOther: 'sélectionnées sur {total}',
        addedByCompany: 'Ajoutée par vous',
        noProposal:
          "Aucune tâche proposée pour cette qualification. Ajoutez celles de l'intérimaire.",
        duplicate: 'Cette tâche est déjà dans la liste.',
        remove: 'Retirer {label}',
        removeTooltip: 'Retirer',
        required: 'Veuillez retenir au moins une tâche',
        checking: 'Vérification en cours',
        rejected:
          "« {label} » n'a pas été ajoutée : ce texte ne décrit pas une tâche du poste.",
        checkingBeforeSave: 'Vérification des tâches…',
        existingChecked: '« {match} » existe déjà : elle a été cochée.',
        existingListed:
          "« {match} » existe déjà dans la liste : elle n'a pas été ajoutée.",
        addAsNewTask: 'Ajouter comme nouvelle tâche',
        closeNotice: 'Fermer',
        notCheckedTooLong:
          "« {label} » n'a pas pu être vérifiée : ajoutez les tâches une par une (80 caractères au plus).",
      },
      responsible: {
        title: 'Responsable sur place',
        description: "La personne que l'intérimaire contactera en arrivant.",
      },
      confirmation: {
        title: 'Tout est bon ?',
        description:
          "Relisez la fiche avant de l'enregistrer. Vous pourrez la modifier plus tard.",
        edit: 'Modifier : {label}',
      },
      summary: {
        name: 'Intitulé',
        activity: 'Secteur',
        qualification: 'Qualification',
        riskyPosition: 'Poste à risque',
        tools: 'Matériel',
        licences: 'Permis',
        languages: 'Langue',
        dressCode: 'Dress code',
        address: 'Adresse',
        salary: 'Taux horaire brut',
        contact: 'Responsable',
        tasks: 'Tâches',
      },
      format: {
        none: 'Aucun',
        noTask: 'Aucune',
        dressCodeMissing: 'Non renseigné',
        toolProvider: {
          company: 'Entreprise',
          temp_worker: 'Intérimaire',
        },
        riskNo: 'Non',
        riskYes: 'Oui',
        riskYesWith: 'Oui · {factors}',
        rate: '{rate} €',
        rateIndexed: '{rate} € · indexé au SMIC',
        contact: '{name} · {poste}',
        tasksTwo: '{first} et {second}',
        tasksMoreOne: '{first}, {second} et 1 autre',
        tasksMoreOther: '{first}, {second} et {count} autres',
      },
      mission: {
        instructionsTitle: 'Consignes',
        instructionsDescription:
          'Propres à cette mission, elles ne modifient pas la fiche de poste.',
        instructionsInterim: "Pour l'intérimaire",
        instructionsInterimPlaceholder:
          "Ex : arrivez 15 min en avance et demandez William à l'accueil",
        instructionsJobbiz: "Pour l'équipe Jobbiz",
        instructionsJobbizPlaceholder: 'Ex : profil autonome souhaité',
        summaryInterim: 'Consignes intérimaire',
        summaryJobbiz: 'Consignes Jobbiz',
        noInstructions: 'Aucune',
      },
    },
    qualification: {
      list: {
        name: 'Nom du poste',
        tasks: 'Tâches',
        sector: 'Secteur',
        createdAt: 'Créé le',
        disabled: 'Désactivé',
        notInBestt: "La mission n'a pas été référencée sur BeSTT",
        tasksCountOne: '{count} tâche',
        tasksCountOther: '{count} tâches',
        tasksCountZero: '0 tâche',
        noTasksWarning:
          "Aucune tâche : les fiches de poste de ce poste n'en proposeront pas",
        create: 'Créer une qualification',
      },
      slideOver: {
        createTitle: 'Créer une qualification',
        close: 'Fermer',
        editTitle: 'Modifier une qualification',
        subtitle:
          'Le poste aura son propre vivier et sera proposé à la création de missions.',
        editSubtitle:
          'Fiche du poste visible par les intérimaires. Elle définit aussi le vivier associé.',
        editTasksSubtitle:
          "Tâches proposées à l'entreprise quand elle crée une mission pour ce poste. Elle peut en retirer ou en ajouter.",
        tabInformations: 'Informations',
        tabTasks: 'Tâches',
        tabTasksWithCount: 'Tâches ({count})',
        tabRisk: 'Poste à risque',
        tabRequirements: 'Prérequis',
        editRiskSubtitle:
          'Indiquez si le poste est à risque et les facteurs concernés. Ils seront repris dans le contrat de mission.',
        editRequirementsSubtitle:
          'Matériel, EPI, permis et CACES nécessaires pour ce poste. Ils sont repris par défaut dans les missions.',
        name: 'Nom du poste',
        nameLocked: "Le nom n'est plus modifiable après la création",
        description: 'Description',
        descriptionHint:
          "Présentez le poste et son contexte. Les tâches se gèrent dans l'onglet Tâches.",
        pcs: 'PCS',
        rome: 'ROME',
        sector: 'Secteur',
        sectorPlaceholder: 'Choisir un secteur',
        sectors: {
          sale: 'Vente',
          logistic: 'Logistique',
          food: 'Restauration',
          largeDistribution: 'Grande distribution',
          administration: 'Administration',
          industry: 'Industrie',
          other: 'Autre',
        },
        missionPreferences: 'Afficher dans « Préférences de missions »',
        missionPreferencesHelp:
          "L'intérimaire pourra ajouter ce poste à sa liste de souhaits.",
        deactivate: 'Désactiver',
        activate: 'Activer',
        cancel: 'Annuler',
        confirm: 'Confirmer',
        confirming: 'Confirmation ...',
        created: 'La qualification a bien été créée.',
        updated: 'La qualification a bien été modifiée.',
        deactivated: 'La qualification a bien été désactivée.',
        activated: 'La qualification a bien été activée.',
        missingFields: 'Veuillez remplir tous les champs.',
        requiredField: 'Champ obligatoire',
        errorInvalidTasks:
          'Les tâches ont été refusées : vérifiez les libellés (80 caractères au plus), les doublons et le nombre de tâches (50 au plus).',
        errorNameImmutable: "Le nom n'est plus modifiable après la création.",
        nameWillLock: 'Le nom ne sera plus modifiable après la création',
        create: 'Créer',
        errorInvalidPcs:
          "Le code PCS est refusé : il doit compter 3 chiffres suivis d'une lettre (ex. 553C).",
        errorInvalidRome:
          'Le code ROME est refusé : il doit être une lettre de A à N suivie de 4 chiffres (ex. N1105), et exister dans le référentiel ROME.',
        errorInvalidAiSuggestion:
          "La proposition de l'IA n'est plus valable. Vérifiez les champs puis cliquez à nouveau sur « Créer » : la qualification sera créée sans elle.",
        warningPcsNotInList:
          "Le code PCS n'appartient pas à la nomenclature PCS-ESE 2017. Il a été enregistré : vérifiez-le.",
        errorRiskFactorRequired:
          "Sélectionnez au moins un facteur de risque, ou indiquez que le poste n'est pas à risque.",
        errorRiskFactorUnknown:
          "Le facteur de risque « {name} » n'existe pas dans la liste. Décochez-le puis enregistrez à nouveau.",
        errorRiskFactorUnknownGeneric:
          "Un facteur de risque coché n'existe pas dans la liste. Vérifiez les facteurs puis enregistrez à nouveau.",
        errorToolUnknown:
          "L'EPI « {name} » n'existe pas dans la liste du matériel. Retirez-le puis enregistrez à nouveau.",
        errorToolUnknownGeneric:
          "Un EPI choisi n'existe pas dans la liste du matériel. Vérifiez les EPI puis enregistrez à nouveau.",
        errorLicenceUnknown:
          "Le permis « {name} » n'existe pas dans la liste des permis. Retirez-le puis enregistrez à nouveau.",
        errorLicenceUnknownGeneric:
          "Un permis choisi n'existe pas dans la liste des permis. Vérifiez les permis puis enregistrez à nouveau.",
      },
      tasks: {
        newTask: 'Nouvelle tâche',
        newTaskPlaceholder: 'Ex. : Nettoyer la zone de quai',
        add: 'Ajouter',
        empty:
          "Aucune tâche pour ce poste. Ajoutez-en ou utilisez l'IA pour en proposer.",
        errorEmpty: 'Saisissez un libellé.',
        errorTooLong: 'Le libellé ne doit pas dépasser {max} caractères.',
        errorDuplicate: 'Cette tâche est déjà dans la liste.',
        limitReached: '{max} tâches au plus par poste.',
        editLabel: 'Libellé de la tâche',
        edit: 'Modifier {label}',
        drag: 'Déplacer {label}',
        remove: 'Supprimer {label}',
        editTooltip: 'Modifier',
        dragTooltip: 'Déplacer',
        removeTooltip: 'Supprimer',
        removeUsedOne:
          'Cette tâche est utilisée dans 1 fiche de poste. Elle restera sur cette fiche mais ne sera plus proposée.',
        removeUsedOther:
          'Cette tâche est utilisée dans {count} fiches de poste. Elle restera sur ces fiches mais ne sera plus proposée.',
        renameUsedOne:
          'Le nouveau libellé sera repris dans la fiche de poste qui utilise cette tâche.',
        renameUsedOther:
          'Le nouveau libellé sera repris dans les {count} fiches de poste qui utilisent cette tâche.',
        confirmRemove: 'Supprimer',
        confirmRename: 'Renommer',
        cancel: 'Annuler',
        dragRoleDescription: 'élément déplaçable',
        dragInstructions:
          'Pour déplacer une tâche, appuyez sur Espace ou Entrée, utilisez les flèches haut et bas, puis Espace ou Entrée pour la déposer, ou Échap pour annuler.',
        dragStart: 'Tâche {label} saisie.',
        dragOver: 'Tâche {label} déplacée sur {over}.',
        dragEnd: 'Tâche {label} déposée.',
        dragCancel: 'Déplacement de la tâche {label} annulé.',
      },
      risk: {
        question: 'Ce poste est-il à risque ?',
        articleLink: "Voir l'article L. 4161-1 du Code du travail",
        factorsLegend: 'Facteurs de risque concernés',
        loading: 'Chargement des facteurs de risque…',
        listError:
          'Impossible de charger la liste des facteurs de risque. Fermez puis rouvrez le panneau pour réessayer.',
        empty: 'Aucun facteur de risque dans la liste.',
      },
      requirements: {
        tools: 'EPI',
        toolsPlaceholder: 'Ajouter du matériel',
        licences: 'Permis',
        licencesPlaceholder: 'Ajouter un permis ou un CACES',
        search: 'Rechercher',
        noResult: 'Aucun résultat',
        remove: 'Retirer {name}',
        removeTooltip: 'Retirer',
        loading: 'Chargement…',
        toolsListError:
          'Impossible de charger la liste du matériel. Les EPI déjà choisis restent enregistrés.',
        licencesListError:
          'Impossible de charger la liste des permis. Les permis déjà choisis restent enregistrés.',
      },
      ai: {
        useAi: "Pré-remplir avec l'IA",
        useAiHelp: "L'IA remplit à partir du nom du poste :",
        generate: 'Créer et générer',
        continue: 'Continuer',
        titleLength:
          "Pour l'IA, le nom du poste doit compter entre {min} et {max} caractères.",
        generatingTitle: "L'IA prépare la fiche du poste",
        generatingButton: 'Génération…',
        counterLabel: 'Étapes terminées : {done} sur {total}',
        steps: {
          description: 'Description',
          sector: 'Secteur',
          tasks: 'Tâches par défaut',
          codes: 'Codes PCS et ROME',
          requirements: 'Poste à risque et prérequis',
        },
        stepTitles: {
          description: 'Description rédigée',
          sector: 'Secteur identifié',
          tasks: 'Tâches par défaut',
          codes: 'Codes PCS et ROME',
          requirements: 'Poste à risque et prérequis',
        },
        stepDone: 'Terminé',
        stepPending: 'En cours…',
        stepWaiting: 'En attente',
        stepRome: 'ROME {code}',
        stepPcs: 'PCS {code}',
        stepSentencesOne: '1 phrase sur le poste et son contexte',
        stepSentencesOther: '{count} phrases sur le poste et son contexte',
        stepTasksZero: 'Aucune tâche proposée',
        stepTasksOne: '1 tâche proposée',
        stepTasksOther: '{count} tâches proposées',
        stepNotAtRisk: 'Pas à risque',
        stepFactorsOne: '1 facteur de risque',
        stepFactorsOther: '{count} facteurs de risque',
        stepToolsOne: '1 EPI',
        stepToolsOther: '{count} EPI',
        stepLicencesOne: '1 permis',
        stepLicencesOther: '{count} permis',
        prefilled: "Pré-rempli par l'IA, à vérifier avant de créer.",
        regenerate: 'Re-générer',
        badge: "Suggéré par l'IA",
        markLabel: 'IA',
        failed:
          'Impossible de proposer une qualification, remplissez les champs manuellement.',
        lowConfidence: {
          rome: 'Confiance faible sur le code ROME proposé : vérifiez-le ou choisissez une alternative.',
          pcs: 'Confiance faible sur le code PCS proposé : vérifiez-le ou choisissez une alternative.',
        },
        alternative: '{code} — {label}',
        similarTitle: 'Des qualifications proches existent déjà',
        similarHelp:
          "Vérifiez qu'elle n'existe pas avant d'en créer une nouvelle.",
        similarDisabled: 'Désactivée',
        alternativeName: 'Autre nom proposé : {name}',
        useAlternativeName: 'Utiliser',
      },
      regenerate: {
        button: "Regénérer avec l'IA",
        loading: 'Chargement de la qualification…',
        before: 'Avant :',
        suggested: "Suggestion de l'IA :",
        restore: 'Rétablir',
        reapply: 'Remettre la suggestion',
        restoreField: 'Rétablir la valeur précédente : {field}',
        reapplyField: "Remettre la suggestion de l'IA : {field}",
        emptyValue: 'Non renseigné',
        notAtRisk: 'Pas à risque',
        atRisk: 'À risque',
        summary:
          "Modifié par l'IA : {fields}. Vérifiez puis confirmez pour enregistrer.",
        summaryNone: "L'IA n'a proposé aucun changement.",
      },
    },
    missionActivity: {
      perimeterChange: {
        title: 'a changé le périmètre',
        field: 'Périmètre',
        none: 'Aucun',
        unnamed: 'Sans nom',
        reasons: {
          manual: 'depuis la fiche de la mission',
          archive_transfer: 'archivage du périmètre d’origine',
          duplicate: 'copie d’une mission d’un périmètre archivé',
        },
      },
    },
    companyContacts: {
      tabLabel: 'Contacts',
      registered: {
        title: 'Inscrit sur Jobbiz',
        add: 'Ajouter',
        pending: 'En attente',
        resendInvitation: 'Renvoyer l’invitation',
        edit: 'Modifier le contact',
        remove: 'Retirer de l’entreprise',
        missingAccount: 'Compte introuvable',
        removeMissingAccount: 'Retirer le compte introuvable',
      },
      hubspot: {
        title: 'Contacts HubSpot',
        description:
          'Contacts de {company} dans HubSpot qui n’ont pas encore de compte Jobbiz.',
        refresh: 'Actualiser les contacts HubSpot',
        collapse: 'Replier les contacts HubSpot',
        expand: 'Déplier les contacts HubSpot',
        invite: 'Inviter',
        error: 'Les contacts HubSpot n’ont pas pu être chargés.',
        retry: 'Réessayer',
      },
      perimeters: {
        title: 'Périmètres',
        description:
          'Limite l’accès des managers aux missions, contrats et relevés d’heures. Sans périmètre, un membre voit tout.',
        allMissions: 'Toutes les missions',
        collapse: 'Replier les périmètres',
        expand: 'Déplier les périmètres',
        list: {
          loadError: 'Les périmètres n’ont pas pu être chargés.',
          retry: 'Réessayer',
          create: 'Créer',
          edit: 'Modifier',
          archive: 'Archiver',
          members: {
            one: '{count} membre',
            many: '{count} membres',
          },
          noMembers: 'Aucun membre rattaché',
        },
        empty: {
          title: 'Aucun périmètre pour l’instant',
          description:
            'Sans périmètre, tous les managers voient toutes les missions, contrats et relevés d’heures. Créez des périmètres (un service, un site, une équipe...) pour limiter leurs accès.',
        },
        form: {
          createTitle: 'Créer un périmètre',
          createDescription:
            'Rattachez les membres qui géreront les missions de ce périmètre. Les membres sans périmètre continuent de tout voir.',
          nameLabel: 'Nom du périmètre',
          namePlaceholder: 'Ex. Cuisine, Site du Lamentin, Équipe de nuit',
          membersLabel: 'Membres rattachés (optionnel)',
          searchPlaceholder: 'Rechercher un membre',
          noAssignableMember: 'Aucun membre à rattacher pour le moment.',
          noSearchResult: 'Aucun membre ne correspond à votre recherche.',
          create: 'Créer',
          creating: 'Création…',
          editTitle: 'Modifier « {name} »',
          editDescription:
            'Les changements s’appliquent tout de suite aux accès des membres.',
          save: 'Enregistrer',
          saving: 'Enregistrement…',
        },
        modal: {
          cancel: 'Annuler',
        },
        delete: {
          title: 'Supprimer « {name} » ?',
          description:
            'Ce périmètre n’est rattaché à aucune mission. Il sera supprimé définitivement.',
          confirm: 'Supprimer',
          deleting: 'Suppression…',
        },
        archive: {
          title: 'Archiver « {name} » ?',
          transferTitle: 'Archiver « {name} »',
          finishedMissions: {
            one: 'La mission terminée garde ce périmètre dans son historique.',
            many: 'Les {count} missions terminées gardent ce périmètre dans leur historique.',
          },
          notProposed:
            'Il ne sera plus proposé pour les nouvelles missions et vous pourrez le restaurer à tout moment.',
          activeMissions: {
            one: '{count} mission en cours ou à venir',
            many: '{count} missions en cours ou à venir',
          },
          transferIntro:
            '{missions} et {members} sont rattachés à ce périmètre. Les missions terminées le gardent dans leur historique.',
          transferLabel: 'Transférer les missions et les membres vers',
          noPerimeter: 'Aucun périmètre',
          confirm: 'Archiver',
          archiving: 'Archivage…',
          usageError:
            'Impossible de vérifier les accès des membres concernés.',
        },
        restore: {
          title: 'Restaurer « {name} » ?',
          description: {
            one: 'Ce périmètre revient sans membre. Sa mission terminée lui sera de nouveau réservée : tant que vous n’y rattachez pas de membres, seuls les administrateurs, les directeurs et les membres sans périmètre la verront.',
            many: 'Ce périmètre revient sans membre. Ses {count} missions terminées lui seront de nouveau réservées : tant que vous n’y rattachez pas de membres, seuls les administrateurs, les directeurs et les membres sans périmètre les verront.',
          },
          restoring: 'Restauration…',
        },
        alert: {
          membersAccess: {
            one: 'Le membre concerné aura accès à toutes les missions, contrats et relevés d’heures.',
            many: 'Les {count} membres concernés auront accès à toutes les missions, contrats et relevés d’heures.',
          },
        },
        archived: {
          heading: 'Archivés ({count})',
          archivedOn: 'Archivé le {date}',
          finishedMissions: {
            one: '{count} mission terminée',
            many: '{count} missions terminées',
          },
          restore: 'Restaurer',
          loadError: 'Les périmètres archivés n’ont pas pu être chargés.',
        },
        toast: {
          created: 'Périmètre créé',
          updated: 'Périmètre modifié',
          archived: 'Périmètre archivé',
          deleted: 'Périmètre supprimé',
          transferred: {
            one: '{count} mission transférée vers {name}',
            many: '{count} missions transférées vers {name}',
          },
          archivedNoPerimeter: {
            one: 'Périmètre « {name} » archivé · {count} mission n’a plus de périmètre',
            many: 'Périmètre « {name} » archivé · {count} missions n’ont plus de périmètre',
          },
          restored: 'Périmètre « {name} » restauré',
        },
        member: {
          restricted: 'Voit uniquement les missions de ces périmètres.',
          none: 'Aucun : voit toutes les missions.',
          unrestricted: 'Voit toujours toutes les missions',
          add: 'Ajouter des périmètres',
          remove: 'Retirer « {name} »',
          loading: 'Chargement des périmètres…',
          loadError:
            'Les périmètres n’ont pas pu être chargés : ils ne seront pas modifiés.',
          saveFailed:
            'Contact enregistré, mais ses périmètres n’ont pas été modifiés. {reason}',
          addModal: {
            title: 'Ajouter des périmètres',
            description:
              'Choisissez les périmètres de {company} auxquels rattacher {name}.',
            searchPlaceholder: 'Rechercher un périmètre',
            noPerimeterLeft: 'Aucun autre périmètre actif à proposer.',
            noSearchResult: 'Aucun périmètre ne correspond à votre recherche.',
            confirm: 'Confirmer',
          },
          errors: {
            notRestrictable:
              'Un directeur ou un administrateur voit toujours toutes les missions : ses périmètres ne se modifient pas.',
            notFound:
              'Un des périmètres choisis n’existe plus : la liste a été actualisée.',
            archived:
              'Un des périmètres choisis vient d’être archivé : la liste a été actualisée.',
            notLoaded:
              'La liste des périmètres n’a pas pu être relue : réessayez dans un instant.',
          },
        },
        errors: {
          generic: 'Une erreur est survenue. Veuillez réessayer.',
          nameRequired: 'Le nom du périmètre est obligatoire.',
          nameTooLong: 'Ce nom est trop long.',
          nameTaken: 'Un périmètre porte déjà ce nom (actif ou archivé).',
          memberInvalid:
            'Ce membre n’est plus disponible : la liste a été actualisée.',
          notFound: 'Ce périmètre n’existe plus.',
          archived:
            'Ce périmètre est archivé : restaurez-le avant de le modifier.',
          alreadyArchived: 'Ce périmètre est déjà archivé.',
          notArchived: 'Ce périmètre n’est plus archivé.',
          inUse:
            'Ce périmètre a déjà été rattaché à une mission : il ne peut plus être supprimé, seulement archivé.',
          transferInvalid:
            'Le périmètre choisi n’est plus disponible pour le transfert.',
          companyNotFound: 'Cette entreprise n’existe plus.',
        },
      },
      roles: {
        200: {
          label: 'Observateur',
          description:
            'L’observateur peut uniquement consulter l’ensemble des factures, relevés d’heures, contrats et missions créés par l’entreprise.',
        },
        205: {
          label: 'Manageur',
          description:
            'Le manager peut uniquement vérifier des relevés d’heures.',
        },
        210: {
          label: 'Responsable',
          description:
            'Le responsable peut signer des contrats, importer des factures, vérifier des relevés d’heures, et créer des missions.',
        },
        215: {
          label: 'Directeur',
          description:
            'Le directeur peut signer des contrats, importer des factures, vérifier des relevés d’heures, et créer des missions et modifier le profil de l’entreprise.',
        },
        220: {
          label: 'Superviseur',
          description:
            'Le superviseur peut créer des missions et vérifier des relevés d’heures.',
        },
        225: {
          label: 'Administrateur',
          description:
            'L’administrateur a tous les droits du directeur ; il gère aussi l’équipe et ses permissions, et reçoit les rappels de l’entreprise.',
        },
      },
      edit: {
        back: 'Retour aux contacts',
        title: 'Modifier le contact',
        subtitle: 'Informations, périmètres et notifications de ce contact',
        firstName: 'Prénom',
        lastName: 'Nom',
        email: 'E-mail',
        role: 'Rôle',
        cancel: 'Annuler',
        save: 'Enregistrer',
        saving: 'Enregistrement…',
        saved: 'Contact enregistré.',
        savedInvitationFailed:
          'Contact enregistré, mais l’invitation n’a pas pu partir. Renvoyez-la depuis la liste des contacts.',
        pendingEmailChange: 'L’invitation sera renvoyée à la nouvelle adresse.',
        activeEmailHint:
          'La nouvelle adresse devient aussitôt son identifiant de connexion ; aucun e-mail ne l’en prévient.',
        lastAdminWarning:
          'L’entreprise n’aura plus d’administrateur : les rappels et plusieurs mails de l’entreprise ne partiront plus à personne.',
        errors: {
          required: 'Ce champ est requis.',
          nameTooLong: '35 caractères au plus.',
          emailInvalid: 'Adresse e-mail invalide.',
          emailTaken: 'Cette adresse est déjà utilisée par un autre compte.',
          adminTaken: '{name} est déjà administrateur de cette entreprise.',
          adminTakenByMissingAccount:
            'Un compte introuvable occupe déjà le rôle Administrateur. Retirez-le de la liste avant d’en nommer un autre.',
          adminTakenUnknown:
            'Un autre membre est déjà administrateur de cette entreprise.',
          memberNotFound: 'Ce membre ne fait plus partie de l’entreprise.',
          generic:
            'Une erreur est survenue, veuillez réessayer ou contacter le support.',
        },
        notifications: {
          title: 'Notifications',
          name: 'Nom',
          perimeter: 'Périmètre',
          all: 'Tout',
          checkboxLabel: '{type} : {column}',
          loading: 'Chargement des notifications…',
          loadError:
            'Les notifications n’ont pas pu être chargées : elles ne seront pas modifiées.',
          retry: 'Réessayer',
          unrestrictedHint:
            'Un directeur ou un administrateur est prévenu pour toutes les missions : la colonne Périmètre ne s’applique pas.',
          noPerimeterHint:
            'Ce contact n’a aucun périmètre : « Périmètre » vaut « Tout » jusqu’à ce qu’il soit rattaché à un périmètre.',
          types: {
            invoices: {
              label: 'Facture',
              description: 'Nouvelle facture émise',
            },
            reminders: {
              label: 'Relances factures',
              description: 'Rappels d’échéances et relances d’impayés',
            },
            contracts: {
              label: 'Contrats',
              description: 'Nouveaux contrats à signer',
            },
            timesheets: {
              label: 'Relevés d’heures',
              description: 'Relevés d’heures à vérifier',
            },
            missions: {
              label: 'Missions',
              description: 'Affectation, annulation et fin des missions',
            },
          },
          saveFailed:
            'Contact enregistré, mais ses notifications n’ont pas été modifiées. {reason}',
          errors: {
            generic: 'Une erreur est survenue. Veuillez réessayer.',
            forbidden:
              'Votre compte n’a pas le droit de modifier les notifications de ce contact.',
            companyNotFound: 'Cette entreprise est introuvable.',
            memberInvalid: 'Ce contact est introuvable.',
            typeInvalid:
              'Un des sujets envoyés n’est pas reconnu : rechargez la fiche puis réessayez.',
            levelInvalid:
              'Le niveau Périmètre ne s’applique ni aux factures, ni à un directeur ou un administrateur : vérifiez les notifications.',
          },
        },
      },
      removal: {
        lastAdminWarning:
          'Ce membre est l’administrateur de l’entreprise : sans lui, les rappels et plusieurs mails de l’entreprise ne partiront plus à personne.',
        missingAccountConfirm:
          'Retirer ce compte introuvable de l’entreprise ?',
      },
      resend: {
        alreadyActive:
          'Ce membre a déjà activé son compte : l’invitation n’est plus nécessaire.',
        failed: 'L’invitation n’a pas pu être renvoyée, veuillez réessayer.',
      },
      invite: {
        title: 'Inviter sur Jobbiz',
        description: '{name} recevra un e-mail pour créer son compte.',
        hubspotDescription:
          '{name} recevra un e-mail pour créer son compte. Ses informations viennent de HubSpot.',
        someone: 'La personne invitée',
        email: 'E-mail',
        firstName: 'Prénom',
        lastName: 'Nom',
        phone: 'Numéro (optionnel)',
        role: 'Rôle',
        cancel: 'Annuler',
        send: 'Envoyer l’invitation',
        sending: 'Envoi…',
        sent: 'Invitation envoyée.',
        attached: 'Compte existant rattaché à l’entreprise.',
        sentMailFailed:
          'Contact ajouté, mais l’invitation n’a pas pu partir. Renvoyez-la depuis la liste des contacts.',
        attachedMailFailed:
          'Compte rattaché, mais l’e-mail qui l’en prévient n’a pas pu partir.',
        errors: {
          phoneInvalid: 'Numéro invalide.',
          alreadyMember: 'Cette personne fait déjà partie de l’entreprise.',
          tempWorker: 'Cette adresse appartient à un compte intérimaire.',
          companyNotFound: 'Cette entreprise n’existe plus.',
        },
        perimeters: {
          steps: 'Étapes de l’invitation',
          information: 'Information',
          notifications: 'Notifications',
          next: 'Suivant',
          label: 'Périmètres',
          none: 'Aucun · toutes les missions',
          unrestricted: 'Voit toujours toutes les missions',
          empty: 'Aucun périmètre actif.',
          loadError:
            'Les périmètres de l’entreprise n’ont pas pu être chargés : sans périmètre, la personne invitée verra toutes les missions.',
          reloadError:
            'La liste des périmètres n’a pas pu être relue : elle peut encore proposer un périmètre qui n’existe plus.',
          retry: 'Réessayer',
          errors: {
            notRestrictable:
              'Un directeur ou un administrateur voit toujours toutes les missions : il ne peut pas être rattaché à un périmètre.',
            notFound:
              'Un des périmètres choisis n’existe plus : la liste a été actualisée. L’invitation n’est pas partie.',
            archived:
              'Un des périmètres choisis vient d’être archivé : la liste a été actualisée. L’invitation n’est pas partie.',
          },
        },
        notifications: {
          noPerimeterHint:
            'Sans périmètre, « Périmètre » vaut « Tout » : ce contact sera prévenu de ses seuls périmètres dès qu’il en aura un.',
          errors: {
            typeInvalid:
              'Un des sujets de notification n’est pas reconnu : rechargez la page puis réessayez. L’invitation n’est pas partie.',
            levelInvalid:
              'Le niveau Périmètre ne s’applique ni aux factures, ni à un directeur ou un administrateur : vérifiez les notifications. L’invitation n’est pas partie.',
          },
        },
      },
      activity: {
        emptyTitle: 'Aucune modification enregistrée',
        emptyText:
          'Les modifications apportées à cette entreprise apparaîtront ici.',
        hubspot: {
          updated: 'HubSpot mis à jour',
          notFound: 'Aucun contact HubSpot avec cette adresse',
          failed: 'Échec de la mise à jour HubSpot',
        },
        invitation: {
          resent: 'Invitation renvoyée à la nouvelle adresse',
          failed: 'L’invitation n’a pas pu être renvoyée',
          fromHubspot: 'Depuis HubSpot',
          notSent: 'L’e-mail n’a pas pu partir',
        },
      },
    },
    companyBilling: {
      cardTitle: 'Informations de facturation',
      billingAddress: 'Adresse de facturation',
      paymentTerm: 'Délai de paiement',
      notSet: 'Non renseigné',
      loadError: 'Les informations de facturation n’ont pas pu être chargées.',
      modalTitle: 'Informations de facturation',
      modalIntro:
        'S’appliquent à toutes les factures de l’entreprise. Une facture peut avoir un délai différent, depuis son détail.',
      companyAddressHint: 'Adresse de l’entreprise',
      companyAddressPrefix: 'Adresse de l’entreprise : {address}',
      noCompanyAddress: 'L’entreprise n’a pas d’adresse.',
      restore: 'Rétablir',
      paymentTermPlaceholder: 'Choisir un délai',
      currentPaymentTerm: 'Actuellement : {term}',
      defaultPaymentTerm: '{term} · par défaut',
      cancel: 'Annuler',
      save: 'Enregistrer',
      saving: 'Enregistrement…',
      saved: 'Informations de facturation enregistrées.',
      savedBesttFailed:
        'Enregistré, mais BeSTT n’a pas été mis à jour : les factures imprimeront l’ancienne adresse.',
      besttNotUpdated: 'BeSTT n’a pas été mis à jour',
      errors: {
        BILLING_ADDRESS_INVALID: 'Adresse incomplète : rue, code postal à 5 chiffres et ville.',
        PAYMENT_TERM_INVALID: 'Délai de paiement invalide.',
        COMPANY_NOT_FOUND: 'Entreprise introuvable.',
        generic: 'Une erreur est survenue, réessayez.',
      },
      paymentTerms: {
        onReceipt: 'À réception',
        days15: '15 jours',
        days30: '30 jours',
        days30EndOfMonth: '30 jours fin de mois',
        days45: '45 jours',
        days45EndOfMonth: '45 jours fin de mois',
        days60: '60 jours',
      },
    },
    companyOverview: {
      address: 'Adresse',
    },
    companyBillingHistory: {
      cardTitle: 'Historique de facturation',
      previousYear: 'Année précédente',
      nextYear: 'Année suivante',
      columnPeriod: 'Période',
      columnNumber: 'N°',
      columnAmount: 'Montant TTC',
      columnPayment: 'Paiement',
      openInvoice: 'Voir la facture {number}',
      loading: 'Chargement…',
      empty: 'Aucune facture en {year}',
      loadError: 'L’historique de facturation n’a pas pu être chargé.',
      retry: 'Réessayer',
      columnCompany: 'Entreprise',
      groupEmpty: 'Aucune facture en {year} pour les entreprises du groupe',
      groupPartialError: 'Les factures de {names} n’ont pas pu être chargées.',
      groupTotalOne: 'Total {year} : {amount} TTC sur {count} facture',
      groupTotalMany: 'Total {year} : {amount} TTC sur {count} factures',
      groupRemaining: 'dont {amount} restant à payer',
    },
    accountStatement: {
      button: 'Relevé de compte',
      title: 'Relevé de compte',
      intro: 'Les mouvements du compte client de l’entreprise chez Pennylane sur la période, à partir du solde au premier jour.',
      from: 'Du',
      to: 'Au',
      datePlaceholder: 'jj/mm/aaaa',
      cancel: 'Annuler',
      download: 'Télécharger le PDF',
      sendMail: 'Envoyer par mail',
      sending: 'Envoi en cours…',
      sentOne: 'Relevé de compte envoyé à {count} destinataire',
      sentMany: 'Relevé de compte envoyé à {count} destinataires',
      sentRedirected: 'Relevé de compte envoyé à l’adresse de test : les contacts ne l’ont pas reçu.',
      recipientsLoading: 'Chargement des contacts de facturation…',
      recipientsLoadFailed: 'Les contacts de facturation n’ont pas pu être chargés.',
      recipientsRetry: 'Réessayer',
      errors: {
        customerNotFound: 'Cette entreprise n’est pas reliée à un client Pennylane.',
        pennylaneUnavailable: 'Pennylane ne répond pas, réessayez dans quelques minutes.',
        readsDisabled: 'La lecture de Pennylane est désactivée sur cet environnement.',
        tooLarge: 'Ce compte contient trop d’écritures pour générer le relevé (plus de 5 000 lignes).',
        invalidPeriod: 'La période est invalide.',
        forbidden: 'Vous n’avez pas accès au relevé de compte.',
        failed: 'Le relevé n’a pas pu être généré.',
        recipientsInvalid: 'Un destinataire coché n’est plus un contact de facturation : fermez et rouvrez la fenêtre.',
        mailDisabled: 'L’envoi de mails est coupé sur cet environnement.',
        mailFailed: 'Le mail n’a pas pu partir, réessayez.',
        mailNetwork: 'Le serveur n’a pas répondu : le mail est peut-être déjà parti.',
      },
    },
    panelCard: {
      edit: 'Modifier {title}',
      fold: 'Replier {title}',
      unfold: 'Déplier {title}',
    },
    companyBillingContacts: {
      card: {
        title: 'Notifications',
        add: 'Ajouter un destinataire',
        edit: 'Modifier {name}',
        loading: 'Chargement des destinataires…',
        loadError: 'Les destinataires des factures n’ont pas pu être chargés.',
        retry: 'Réessayer',
        nobody: 'Personne ne reçoit les factures ni les relances.',
        groups: {
          members: {
            title: 'Inscrit sur Jobbiz',
            info: 'Membres de l’entreprise, avec un compte Jobbiz, qui reçoivent les factures ou les relances.',
            empty: 'Aucun membre ne reçoit les factures ni les relances.',
          },
          externals: {
            title: 'Non inscrit sur Jobbiz',
            info: 'Personnes sans compte Jobbiz, ajoutées seulement pour recevoir les factures ou les relances.',
            empty: 'Aucun contact sans compte.',
          },
        },
        receives: {
          both: 'Factures, relances',
          invoices: 'Factures',
          reminders: 'Relances',
          none: 'Aucune notification',
        },
        memberStatus: {
          pending: 'Invitation en attente',
        },
      },
      add: {
        title: 'Ajouter un contact de facturation',
        loading: 'Chargement des membres…',
        loadError: 'Les membres de l’entreprise n’ont pas pu être chargés.',
        retry: 'Réessayer',
      },
      picker: {
        intro:
          'Choisissez un membre de l’entreprise ou ajoutez un contact de facturation sans compte Jobbiz. Les factures lui seront envoyées par mail.',
        searchLabel: 'Rechercher un membre ou saisir une adresse e-mail',
        searchPlaceholder: 'Nom, prénom ou e-mail',
        membersGroup: 'Membres de l’entreprise',
        alreadyRecipient: 'Déjà destinataire',
        noMember: 'Aucun membre ne correspond à la recherche.',
        addExternal: 'Ajouter « {query} » comme contact de facturation',
        addExternalHint: 'Reçoit les factures par mail, sans compte Jobbiz',
      },
      member: {
        editTitle: 'Modifier le contact de facturation',
        remove: 'Retirer des destinataires',
      },
      external: {
        editTitle: 'Modifier le contact de facturation',
        description:
          'Cette personne recevra les factures par mail, sans compte Jobbiz. Elle sera aussi ajoutée sur HubSpot.',
        email: 'E-mail',
        firstName: 'Prénom',
        lastName: 'Nom',
        phone: 'Numéro (optionnel)',
        invite: 'Inviter sur Jobbiz',
        delete: 'Supprimer ce contact',
        deleteTitle: 'Supprimer {name} ?',
        deleteConfirmation: 'Il ne recevra plus les factures ni les relances.',
        confirmDelete: 'Supprimer',
        deleting: 'Suppression…',
      },
      notifications: {
        label: 'Notifications',
        invoices: 'Factures',
        invoicesHint: 'Nouvelle facture émise',
        reminders: 'Relances',
        remindersHint: 'Rappels d’échéances et relances d’impayés',
      },
      actions: {
        add: 'Ajouter',
        back: 'Retour',
        cancel: 'Annuler',
        save: 'Enregistrer',
        saving: 'Enregistrement…',
      },
      toasts: {
        added: 'Contact de facturation ajouté.',
        saved: 'Contact de facturation enregistré.',
        removed: 'Retiré des destinataires.',
        deleted: 'Contact de facturation supprimé.',
      },
      errors: {
        required: 'Ce champ est requis.',
        nameTooLong: '35 caractères au plus.',
        emailInvalid: 'Adresse e-mail invalide.',
        phoneInvalid: 'Numéro invalide.',
        contactIsMember:
          'Cette adresse est celle d’un membre de l’entreprise : choisissez-le dans la recherche.',
        contactExists:
          'Cette adresse est déjà un contact de facturation de l’entreprise.',
        notificationsEmpty: 'Cochez au moins une case : Factures ou Relances.',
        notificationsInvalid: 'Ces notifications ne sont pas valides.',
        contactNotFound: 'Ce contact de facturation n’existe plus.',
        memberNotFound: 'Ce membre ne fait plus partie de l’entreprise.',
        companyNotFound: 'Entreprise introuvable.',
        generic: 'Une erreur est survenue, réessayez.',
      },
      activity: {
        ajouter_contact_facturation: 'a ajouté le contact de facturation',
        modifier_contact_facturation: 'a modifié le contact de facturation',
        supprimer_contact_facturation: 'a supprimé le contact de facturation',
        fields: {
          email: 'E-mail',
          firstname: 'Prénom',
          lastname: 'Nom',
          phone: 'Numéro',
          invoices: 'Factures',
          reminders: 'Relances',
        },
        line: '{field} : {before} → {after}',
        yes: 'Oui',
        no: 'Non',
        empty: '—',
      },
    },
    postIt: {
      title: 'Post-it',
      where:
        'Cette consigne s’affiche sur la fiche entreprise, le détail de relevé d’heures, le détail de mission, l’aperçu du contrat et le détail de facture.',
      label: 'Contenu',
      placeholder: 'Particularité de saisie, contact à prévenir…',
      clearHint: 'Videz le champ pour retirer le post-it.',
      loadFailed: 'Le post-it n’a pas pu être chargé. Fermez et réessayez.',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      saving: 'Confirmation ...',
      saved: 'Le post-it a bien été enregistré',
      saveFailed: 'L’enregistrement a échoué',
    },
    visaComplementary: {
      types: {
        new_permit: 'Nouveau titre de séjour',
        receipt: 'Récépissé de renouvellement',
        anef_extension: "Attestation de prolongation d'instruction (ANEF)",
      },
      item: {
        endValidity: 'Valable jusqu’au {date}',
        noEndValidity: 'Date de fin non confirmée',
        sentOn: 'Envoyé le {date}',
        open: 'Ouvrir le justificatif',
      },
      modal: {
        title: 'Justificatif de prolongation',
        notFound: 'Ce justificatif est introuvable sur le profil.',
        documentType: 'Type de justificatif',
        empty: '—',
        currentPermitEnd: 'Fin du titre actuel',
        endValidityLabel: 'Valable jusqu’au',
      },
      toasts: {
        accepted: 'Justificatif validé',
        endValidityRequired: 'Renseignez une date de fin de validité valide.',
      },
      errors: {
        badState:
          'Ce justificatif a déjà été traité : rouvrez la fiche pour voir son état.',
        invalidEndValidity: 'La date de fin de validité n’est pas valide.',
        reasonNotFound: 'Ce motif de refus n’existe plus : choisissez-en un autre.',
        notFound: 'Ce justificatif est introuvable sur le profil.',
        generic: 'Une erreur est survenue, veuillez réessayer.',
      },
    },
    licenceValidation: {
      documentType: {
        label: 'Type de document',
        identity: 'Identité',
        identityDescription:
          'Pièce d’identité, selfie, titre de séjour, carte Vitale, justificatif',
        licence: 'Permis/CACES',
        licenceDescription: 'Permis de conduire et certificats CACES',
      },
      tabs: {
        pending: 'En attente',
        validated: 'Validé par IA',
      },
      categoryLabel: 'catégorie {category}',
      status: {
        pending: 'À vérifier',
        accepted: 'Validé',
        refused: 'Refusé',
      },
      verify: 'Vérifier {licence}',
      openTempWorker: 'Voir la fiche',
      footer: {
        pendingOne:
          'Affichage de {shown} intérimaire sur {total} ({pending} permis/CACES à vérifier au total)',
        pendingMany:
          'Affichage de {shown} intérimaires sur {total} ({pending} permis/CACES à vérifier au total)',
        validated: 'Affichage de {shown} permis/CACES sur {total}',
      },
      empty: {
        pendingTitle: 'Aucun permis/CACES à vérifier',
        pendingDescription:
          'Les permis et CACES envoyés par les intérimaires apparaîtront ici.',
        validatedTitle: 'Aucun permis/CACES validé par l’IA',
        validatedDescription:
          'Les permis et CACES acceptés par l’IA apparaîtront ici.',
        searchTitle: 'Aucun résultat',
        searchDescription: 'Aucun permis/CACES ne correspond à votre recherche.',
      },
      error: {
        title: 'Chargement impossible',
        description: 'La liste des permis/CACES n’a pas pu être chargée.',
        retry: 'Réessayer',
      },
      modal: {
        otherDocuments: 'Autres documents',
        replaced: 'Remplacé',
        drivingLicence: 'Permis de conduire',
        caces: 'CACES',
        subtitle: '{licence} · {pages}',
        pages: {
          single: 'document unique',
          double: 'recto & verso',
          many: 'plusieurs documents',
        },
        rotate: 'Pivoter d’un quart de tour',
        licenceLabel: 'Permis / CACES',
        licencePlaceholder: 'Choisir un permis ou un CACES',
        expirationLabel: 'Date de fin de validité',
        clearExpiration: 'Effacer la date',
        expirationRequiredHint:
          'Un CACES ne s’accepte pas sans date de fin de validité.',
        aiTitle: 'Analyse automatique',
        accept: 'Accepter',
        refuse: 'Refuser',
        notFound: 'Ce permis est introuvable sur le profil.',
        readOnly: {
          accepted: 'Ce permis a été validé.',
          refused: 'Ce permis a été refusé : {reason}',
          refusedNoReason: 'Ce permis a été refusé.',
          replaced: 'Ce permis a été remplacé le {date} par un nouvel envoi.',
          replacedNoDate: 'Ce permis a été remplacé par un nouvel envoi.',
        },
      },
      toasts: {
        accepted: 'Permis validé.',
        refused: 'Permis refusé.',
        reasonRequired: 'Choisissez un motif de refus.',
      },
      errors: {
        expirationRequired:
          'Un CACES ne s’accepte pas sans date de fin de validité.',
        notPending:
          'Ce permis a déjà été traité : fermez la fenêtre pour voir son état.',
        notInCatalogue:
          'Ce permis n’existe pas au catalogue : choisissez-en un autre.',
        notFound: 'Ce permis est introuvable sur le profil.',
        tempWorkerNotFound: 'Cet intérimaire est introuvable.',
        reasonNotFound:
          'Ce motif de refus n’existe plus : choisissez-en un autre.',
        loadFailed: 'Le permis n’a pas pu être chargé.',
        catalogueFailed: 'La liste des permis n’a pas pu être chargée.',
        generic: 'Une erreur est survenue, veuillez réessayer.',
      },
    },
    companyPanel: {
      detailedView: 'Vue détaillée',
    },
    agencyGoals: {
      pageTitle: 'Paramètres · Objectifs de l’agence',
      previousYear: 'Année précédente',
      nextYear: 'Année suivante',
      loadError: 'Les objectifs de l’agence n’ont pas pu être chargés.',
      retry: 'Réessayer',
      globalTitle: 'Objectif de CA {year}',
      globalText: 'Le chiffre d’affaires à atteindre sur l’année. Le tableau des territoires le répartit jusqu’à 0.',
      left: 'Reste à répartir : {amount}',
      shared: 'Objectif entièrement réparti',
      over: 'Le tableau dépasse l’objectif de {amount}',
      noTerritory: 'Aucun territoire : ils viennent des départements des entreprises.',
      colTerritory: 'Territoire',
      colClients: 'Nouveaux clients',
      colRevenue: 'CA visé',
      total: 'Total',
      unsaved: 'Modifications non enregistrées',
      invalid: 'Un nombre de clients est un entier, les montants des nombres positifs.',
      cancel: 'Annuler',
      save: 'Enregistrer',
      saved: 'Objectifs de l’agence enregistrés',
      saveError: 'Les objectifs n’ont pas pu être enregistrés, réessayez.',
      cardTitle: 'Objectifs de l’agence · {year}',
      colSigned: 'Clients signés',
      colRevenueDone: 'CA généré',
      cardEmpty: 'Aucun objectif pour {year} : ils se règlent dans la console d’administration, Paramètres › Objectifs de l’agence.',
      ofGoal: '{done} / {goal}',

      etpTitle: 'Ce que vaut un ETP',
      etpText: 'Un ETP, c’est un intérimaire à temps plein : le SMIC d’un mois facturé au coefficient moyen.',
      smic: 'SMIC horaire brut {amount} €',
      hours: '{hours} h par mois',
      coefficient: 'Coefficient de facturation moyen',
      price: '{amount} par ETP et par mois',
      rampText: 'Un nouveau client démarre à quelques ETP le mois où il signe, puis grandit chaque mois jusqu’aux ETP de sa taille.',
      rampStart: 'démarre à',
      rampStartOf: 'ETP au démarrage : {size}',
      rampGrowth: 'grandit de',
      rampGrowthOf: 'Croissance mensuelle : {size}',
      perMonth: '% par mois',
      rampMax: 'jusqu’à',
      rampMaxOf: 'ETP au plus : {size}',
      planTitle: 'Plan d’action',
      planText: 'Les nouveaux clients à signer chaque mois, par territoire et par taille. Les lignes des territoires donnent le CA de chaque mois.',
      clientsIn: 'Nouveaux clients {size}, {territory}, {month}',
      cardAside: 'le trait : où le plan attend l’agence aujourd’hui',
    },
    stats: {
      previous: 'Période précédente',
      next: 'Période suivante',
      kind_week: 'Semaine',
      kind_month: 'Mois',
      kind_quarter: 'Trimestre',
      kind_custom: 'Période',
      myReview: 'Mon bilan de la semaine',
      loadError: 'Les statistiques n’ont pas pu être chargées.',
      retry: 'Réessayer',
      noCommercialTitle: 'Aucun commercial dans l’équipe',
      noCommercialText: 'Les statistiques suivent les comptes Commercial : elles s’affichent dès qu’il y en a un.',
      versus: 'vs {period}',
      weekShort: 'S{n}',
      weekLabel: 'S{n} · {range}',
      monthLabel: '{month} {year}',
      quarterShort: 'T{n}',
      quarterLabel: 'T{n} {year} · {from} – {to}',
      ofMonth: 'de {month}',
      ofMonthVowel: 'd’{month}',
      hi: ', {name}',
      bannerCustomReached: 'Objectif atteint sur la période',
      bannerCustomOngoing: 'Période en cours',
      bannerCustomOver: 'Période terminée',
      bannerCustomTextOne: '{n} RDV pris sur {goal} visés, {count} jour à {weekGoal} par semaine.',
      bannerCustomTextOther: '{n} RDV pris sur {goal} visés, {count} jours à {weekGoal} par semaine.',
      bannerReviewDo: 'Faire mon bilan de la semaine',
      bannerReviewAgain: 'Revoir mon bilan',
      bannerReviewSee: 'Voir son bilan',
      pillStreakOne: '1 semaine de bilan',
      pillStreak: '{count} semaines d’affilée',
      bannerWeekReached: 'Belle semaine{hi} !',
      bannerWeekReachedOther: 'Objectif de la semaine atteint',
      bannerWeekReachedText: 'Objectif atteint : {n} RDV pris sur {goal}.',
      bannerBestWeeksOwn: ' C’est votre meilleure semaine depuis {count} semaines.',
      bannerBestMonthsOwn: ' C’est votre meilleure semaine depuis {count} mois.',
      bannerBestWeeksOther: ' Meilleure semaine depuis {count} semaines.',
      bannerBestMonthsOther: ' Meilleure semaine depuis {count} mois.',
      bannerWeekOngoing: 'Encore un effort{hi} !',
      bannerWeekOngoingOther: 'Semaine en cours',
      bannerWeekOngoingText: '{n} RDV pris sur {goal} visés cette semaine. Encore {left} pour atteindre l’objectif.',
      bannerWeekOver: 'Semaine {period} terminée',
      bannerWeekOverText: '{n} RDV pris sur {goal} visés.',
      pillMonthOngoingOne: '{count} bilan sur {total} ce mois-ci',
      pillMonthOngoingOther: '{count} bilans sur {total} ce mois-ci',
      pillMonthOverOne: '{count} bilan sur {total} en {month}',
      pillMonthOverOther: '{count} bilans sur {total} en {month}',
      pillQuarterOne: '{count} bilan sur {total}',
      pillQuarterOther: '{count} bilans sur {total}',
      bannerMonthLink: 'Voir le détail par semaine',
      bannerMonthReached: 'Objectif du mois atteint',
      bannerMonthText: '{n} RDV sur {goal} visés en {month}.',
      bannerMonthStart: 'Bon début de mois',
      bannerMonthMiddle: 'Mi-parcours',
      bannerMonthEnd: 'Dernière ligne droite',
      bannerMonthOngoingText: '{n} RDV sur {goal} visés en {month}. Encore {left} pour atteindre l’objectif.',
      bannerMonthOver: '{month} terminé',
      bannerQuarterLink: 'Comparer avec le {period}',
      bannerQuarterReached: 'Objectif du trimestre atteint',
      bannerQuarterSolid: 'Un trimestre solide',
      bannerQuarterOngoing: 'Le trimestre est lancé',
      bannerQuarterOver: '{period} terminé',
      bannerQuarterText: '{n} RDV sur {goal} visés, soit {pct} % de l’objectif du {period}.',
      reminder: 'C’est {day} : 2 minutes pour faire le bilan de votre semaine.',
      reminderCta: 'Faire mon bilan',
      prospection: 'Prospection',
      funnel_calls: 'Personnes appelées',
      funnel_pickedUp: 'Ont décroché',
      funnel_discussions: 'Discussions engagées',
      funnel_rdvTaken: 'RDV pris',
      ratePickedUp: 'Décroché',
      rateDiscussion: 'Discussion',
      rateRdvPerDiscussion: 'RDV / discussions',
      rateRdvPerCall: 'RDV / appels',
      results: 'Résultats',
      resultHeldOne: 'RDV réalisé',
      resultHeldOther: 'RDV réalisés',
      resultInboundOne: 'Demande entrante',
      resultInboundOther: 'Demandes entrantes',
      resultSalesOne: 'Vente signée',
      resultSalesOther: 'Ventes signées',
      resultRevenue: 'CA généré',
      resultRevenueEstimated: 'dont {amount} estimés',
      resultRevenueEstimatedHint:
        'Une vente sans facture compte pour le montant estimé de ses relevés d’heures.',
      resultShowUp: 'Show-up',
      resultClosing: 'Closing',
      record: 'Record',
      goalLabel: 'Objectif : {value}',
      weekBar: 'S{n}',
      chartTitleDay: '{metric} par jour{suffix}',
      chartTitleWeek: '{metric} par semaine{suffix}',
      metric_rdvTaken: 'RDV pris',
      metric_calls: 'Personnes appelées',
      metric_pickedUp: 'Ont décroché',
      metric_discussions: 'Discussions engagées',
      metric_rdvDone: 'RDV réalisés',
      metric_sales: 'Ventes signées',
      metricTitle_rdvTaken: 'RDV pris',
      metricTitle_calls: 'Appels',
      metricTitle_pickedUp: 'Décrochés',
      metricTitle_discussions: 'Discussions',
      metricTitle_rdvDone: 'RDV réalisés',
      metricTitle_sales: 'Ventes',
      feelingMine: 'Mon ressenti',
      feelingOf: 'Ressenti de {name}',
      feelingTeam: 'Ressenti de l’équipe',
      feeling_confidence: 'Confiance en call',
      feeling_questioning: 'Questionner',
      feeling_objections: 'Objections',
      feeling_energy: 'Énergie',
      feelingAsideWeek: 'bilan S{n}',
      feelingAsideWeekAverage: 'moyenne {period}',
      feelingAsideMonth: 'moyenne {month}',
      feelingAsideQuarter: 'moyenne du {period}',
      feelingAsideCustom: 'moyenne de la période',
      feelingEmptyOwn: 'Pas encore de bilan : faites le premier pour suivre votre ressenti.',
      feelingEmptyOther: 'Pas encore de bilan.',
      feelingEmptyWeek: 'Aucun bilan en {period}.',
      feelingEmptyMonth: 'Aucun bilan en {month}.',
      feelingEmptyQuarter: 'Aucun bilan au {period}.',
      feelingEmptyCustom: 'Aucun bilan sur la période.',
      dots: '{value} sur 5',
      pickerPrevious: 'Précédent',
      pickerNext: 'Suivant',
      weekdayInitials: 'L,M,M,J,V,S,D',
      quarterTile: 'T{n} · {from} – {to}',
      rangeFirst: 'Choisissez le premier jour',
      rangeLast: 'Choisissez le dernier jour',
      rangeDaysOne: '{count} jour',
      rangeDaysOther: '{count} jours',
      rangeApply: 'Appliquer',
      reviewTitle: 'Mon bilan · S{n}',
      reviewOfTitle: 'Bilan de {name} · S{n}',
      reviewIntro: '2 minutes pour faire le point. Visible par vous et votre responsable d’agence.',
      savedOn: 'Enregistré le {day} · visible par vous et votre responsable d’agence',
      savedOnBy: 'Enregistré le {day}',
      noReviewYet: 'Pas encore de bilan pour cette semaine.',
      chipCallsOne: '{count} appel',
      chipCallsOther: '{count} appels',
      chipRdv: '{count} RDV pris',
      chipSalesOne: '{count} vente',
      chipSalesOther: '{count} ventes',
      scaleLow: '1 = à travailler',
      scaleHigh: '5 = au top',
      scale_confidence: 'Ma confiance en call',
      scale_questioning: 'Ma capacité à questionner',
      scale_questioningHint: 'plutôt qu’argumenter',
      scale_objections: 'Ma gestion des objections',
      scale_energy: 'Mon énergie, ma motivation',
      victoryLabel: 'Ma victoire de la semaine',
      victoryPlaceholder: 'Un appel, un rendez-vous, un retour client…',
      challengeLabel: '1 seul défi pour la semaine prochaine',
      challengePlaceholder: 'Un défi concret, mesurable',
      later: 'Plus tard',
      close: 'Fermer',
      saveReview: 'Enregistrer mon bilan',
      saveError: 'Le bilan n’a pas pu être enregistré, réessayez.',
      savedTitle: 'Bilan enregistré',
      savedChallenge: 'Votre défi pour la semaine prochaine : {challenge}.',
      savedReminder: ' On vous le rappelle lundi matin.',
      savedNoChallenge: 'Votre bilan de la semaine est enregistré.',
      savedStreak: '{count} semaines de bilan d’affilée',
      savedFirst: 'Premier bilan de votre série',
    },
    adminConsole: {
      roleSelectLabel: 'Rôle de {name}',
      roleMissions: 'Missions',
      roleUpdated: 'Rôle mis à jour',
      roleErrors: {
        memberNotFound:
          'Ce membre est introuvable : la liste a été actualisée.',
        unknownRole: 'Ce rôle n’existe pas.',
        notAnAdmin:
          'Ce compte ne fait pas partie de l’équipe : la liste a été actualisée.',
        memberDeactivated:
          'Ce membre est désactivé : réactivez-le avant de changer son rôle.',
        ownRole: 'Vous ne pouvez pas changer votre propre rôle.',
        superAdmin:
          'Le rôle d’un responsable d’agence ne peut pas être changé.',
        generic: 'Le rôle n’a pas pu être mis à jour, réessayez.',
      },
      deactivateErrors: {
        self: 'Vous ne pouvez pas désactiver vos propres accès.',
        superAdmin:
          'Les accès d’un responsable d’agence ne peuvent pas être désactivés.',
        memberNotFound: 'Ce membre est introuvable.',
        generic: 'Les accès n’ont pas pu être désactivés, réessayez.',
      },
      sizesPageTitle: 'Paramètres · Taille des clients',
      sizesTitle: 'Taille des clients',
      sizesText: 'Un prospect garde la taille choisie à sa création. Une entreprise cliente prend la sienne de ses relevés d’heures, selon ces seuils.',
      sizesSize: 'TAILLE',
      sizesRule: 'RÈGLE',
      sizesFrom: 'À partir de',
      sizesEtp: 'ETP',
      sizesInputLabel: 'Seuil en ETP : {size}',
      sizesBelow: 'Moins de {etp} ETP',
      sizesHow: 'ETP : les heures des relevés des 3 derniers mois complets, divisées par 151,67 h par mois, puis par 3. Tant qu’une cliente n’a pas de relevé, elle garde la taille choisie.',
      sizesInvalid: 'Un seuil est un nombre d’ETP supérieur à 0.',
      sizesOrder: 'Le seuil d’une PME est inférieur à celui d’un grand compte.',
      sizesSaved: 'Seuils enregistrés',
      sizesSaveError: 'Les seuils n’ont pas pu être enregistrés, réessayez.',
      sizesLoadError: 'Les seuils n’ont pas pu être chargés.',
      goalsPageTitle: 'Paramètres · Objectifs des commerciaux',
      goalsTitle: 'Objectifs',
      goalsText: 'Ce que vise chaque commercial : ses appels et ses RDV pris par semaine, ses RDV réalisés, ses ventes et son CA par mois. Ils s’affichent dans Statistiques, à côté de ses chiffres.',
      goalsCommercial: 'COMMERCIAL',
      goalsRdvWeek: 'RDV PRIS / SEMAINE',
      goalsInputLabel: '{goal} visés par {name}',
      goalsNone: 'Aucun commercial actif.',
      goalsLoadError: 'Les objectifs n’ont pas pu être chargés.',
      goalsRetry: 'Réessayer',
      goalsUnsaved: 'Modifications non enregistrées',
      goalsInvalid: 'Un objectif est un nombre entier, 0 ou plus.',
      goalsCancel: 'Annuler',
      goalsSave: 'Enregistrer',
      goalsSaved: 'Objectifs enregistrés',
      goalsSaveError: 'Les objectifs n’ont pas pu être enregistrés, réessayez.',
      goalsColumn_calls: 'APPELS / SEM.',
      goalsColumn_rdvTaken: 'RDV PRIS / SEM.',
      goalsColumn_rdvDone: 'RDV RÉALISÉS / MOIS',
      goalsColumn_sales: 'VENTES / MOIS',
      goalsColumn_revenue: 'CA / MOIS (€)',
      goalsName_calls: 'Appels par semaine',
      goalsName_rdvTaken: 'RDV pris par semaine',
      goalsName_rdvDone: 'RDV réalisés par mois',
      goalsName_sales: 'Ventes par mois',
      goalsName_revenue: 'CA par mois',
    },
    createMission: {
      coefficient: {
        title: 'Coefficient de facturation',
        loading: 'Chargement…',
        companyValue: '{value} — valeur entreprise',
        noRange: 'Aucune tranche exploitable pour ce salaire',
        unavailable: 'Valeur entreprise indisponible',
        overridden: '{value} — modifié pour cette mission',
        overriddenCompany: 'Valeur entreprise : {value}',
        edit: 'Modifier',
        inputLabel: 'Coefficient de la mission',
        emptyHint:
          'Laissé vide, le coefficient suit la grille de l’entreprise.',
        invalid:
          'Saisissez un coefficient supérieur à 0 et inférieur à 10 (ex. 1,85).',
        reset: 'Revenir à la valeur de l’entreprise',
      },
      perimeter: {
        title: 'Périmètre',
        description:
          'Les managers du périmètre choisi voient la mission. Les directeurs et administrateurs voient toujours toutes les missions.',
        label: 'Périmètre de la mission',
        none: 'Aucun périmètre',
        noneHint: 'Visible par tous les managers',
        loading: 'Chargement des périmètres…',
        loadError:
          'Les périmètres de l’entreprise n’ont pas pu être chargés : sans eux, la mission sera visible par tous les managers.',
        retry: 'Réessayer',
        errors: {
          notFound:
            'Le périmètre choisi n’existe plus : la liste a été actualisée, choisissez-en un autre.',
          archived:
            'Le périmètre choisi vient d’être archivé : la liste a été actualisée, choisissez-en un autre.',
        },
      },
    },
    crmUi: {
      markTodo: 'Marquer à faire',
      markDone: 'Marquer comme terminé',
      choose: 'Choisir',
      close: 'Fermer',
      previousMonth: 'Mois précédent',
      nextMonth: 'Mois suivant',
      chooseDay: 'Choisir un jour',
      filters: 'Filtres',
      removeFilter: 'Retirer le filtre',
      reset: 'Réinitialiser',
      apply: 'Appliquer',
      assign: 'Attribuer',
      meSuffix: '{name} (moi)',
    },
  },
};
